<template>
	<section v-if="isShowH" class="py-5 box-layout-details" style="overflow:auto;height:100vh;">
        <div>
            <b-form class="p-3 row align-items-center">
                <b-form-group label="Start Date" class="text-left col-sm-3 start-date">
                    <b-form-group>
                        <b-form-datepicker
                            v-model="form.date_s"
                            size="sm"
                            required/>
                    </b-form-group>
                </b-form-group>
                <b-form-group label="End Date" class="text-left col-sm-3 end-date">
                    <b-form-group class="date_picker_add">
                        <b-form-datepicker 
                            v-model="form.date_e"
                            size="sm"
                            required/>
                    </b-form-group>
                </b-form-group>
                
                <b-button-group class="w-100 col-sm-6 filter-btn">
                    <vue-multi-select
                        ref="multiSelect"
                        class="multiSelectdiv"
                        :options="options11"
                        :btnLabel="CheckboxLabel"
                        :selectOptions="OfficeDataCheckbox">
                        <template v-slot:option="{option}">
                            
                            <label :for='option.OfficeId' v-if="option.hasOwnProperty('OfficeName')"
                            style="width: 100%; margin-bottom: 0px;padding:5px; font-size:15px;">
                            <input type="checkbox" 
                            :id="option.OfficeId" 
                            :value="option.OfficeId" 
                            @change="checkFilterByOfficeValue1($event)">
                            {{option.name}}</label>
                            
                            <label :for='option.MgrID' v-if="option.hasOwnProperty('First')"
                            style="width: 100%; margin-bottom: 0px;padding:5px; font-size:15px;">
                            <input type="checkbox" 
                            :id="option.MgrID" 
                            :value="option.MgrID" 
                            @change="checkFilterByManagerValue1($event)">
                            {{option.name}}</label>

                            <label :for='option.id' 
                            style="width: 100%; margin-bottom: 0px;padding:5px; font-size:15px;">
                            <input type="checkbox" 
                            :id="option.id" 
                            :value="option.id"
                            @change="checkFilterBySourceValue1($event)">
                            {{option.name}}</label>

                        </template>
                    </vue-multi-select>
                    <b-button variant="outline-primary" @click="applyFilter" style="border-radius: 3px;" :disabled="disabledStatus"> 
                            <div v-if="!isShowAnalytics" class="col-sm-12 text-center loader-blue" style="position: absolute;padding-left: 0;text-align: left !important;">
                            <div class="loader4 "></div>
                        </div>
                        <div v-if="isShowAnalytics">Run Report</div> 
                    </b-button>
                    <download-csv v-if="this.dateRangeProspect.length" style="margin-left: 10px;"
                        class="btn-default"
                        :data="this.getCSVData()"
                        :name="this.getFileName()"
                        :fields="reportingFields"
                        :labels="reportingLabels"
                        >
                        <b-button variant="outline-primary" style="padding: 5px 35px;">Export Prospects</b-button>
                    </download-csv>
                </b-button-group>
            </b-form>

            <div class="container-fluid">
                <div class="row rowphases">
                    <div class="col-lg-12"><h5 class="HeadingCenter test dtest">Recruiting Pipeline as of {{this.TodaysDate}}</h5></div>
                    
                    <!--<div class="col-lg-2">
                        <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                            <div class="">
                                <div class="col-auto" style="height:120px;">
                                    <div class="MatrixExportIcon" style="top:0px;" 
                                    v-b-tooltip.hover title="Total Prospects in the “New” Stage.">
                                    <v-icon name="question"></v-icon>
                                    </div>
                                    <h6 class="m-b-10">New</h6>
                                    <h2 class="m-b-0">{{Phase1newCount}}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2">
                        <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                            <div class="">
                                <div class="col-auto" style="height:120px;">
                                    <div class="MatrixExportIcon" style="top:0px;" 
                                    v-b-tooltip.hover title="Total Prospects in the “Contacted” Stage.">
                                    <v-icon name="question"></v-icon>
                                    </div>
                                    <h6 class="m-b-10">Contacted</h6>
                                    <h2 class="m-b-0">{{Phase1ContactedCount}}</h2>
                                </div>
                            </div>
                        </div>
                    </div>-->

                    <div class="col-lg-2">
                        <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                            <div class="">
                                <div class="col-auto" style="height:120px;">
                                    <div class="MatrixExportIcon" style="top:0px;" 
                                    v-b-tooltip.hover title="Total Prospects in the “Pre-Interview Nurture” Stage.">
                                    <v-icon name="question"></v-icon>
                                    </div>
                                    <h6 class="m-b-10">Pre-Interview Nurture</h6>
                                    <h2 class="m-b-0 tileNumber">{{Phase1PreInterviewNurtureCount}}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2">
                        <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                            <div class="">
                                <div class="col-auto" style="height:120px;">
                                    <div class="MatrixExportIcon" style="top:0px;" 
                                    v-b-tooltip.hover title="Total Prospects in the “Post-Interview Nurture” Stage.">
                                    <v-icon name="question"></v-icon>
                                    </div>
                                    <h6 class="m-b-10">Post-Interview Nurture</h6>
                                    <h2 class="m-b-0 tileNumber">{{Phase1PostInterviewNurtureCount}}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2">
                        <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                            <div class="">
                                <div class="col-auto" style="height:120px;">
                                    <div class="MatrixExportIcon" style="top:0px;" 
                                    v-b-tooltip.hover title="Total Prospects in the “Offer” Stage">
                                    <v-icon name="question"></v-icon>
                                    </div>
                                    <h6 class="m-b-10">Offer</h6>
                                    <h2 class="m-b-0 tileNumber">{{Phase1OfferCount}}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2">
                        <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                            <div class="">
                                <div class="col-auto" style="height:120px;">
                                    <div class="MatrixExportIcon" style="top:0px;" 
                                    v-b-tooltip.hover title="Projected Hires for the current calendar year. Based on current Year-to-Date Hires.">
                                    <v-icon name="question"></v-icon>
                                    </div>
                                    <h6 class="m-b-10">Projected Hires</h6>
                                    <h2 class="m-b-0 tileNumber">{{FinalValueProjectedHires}}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container-fluid">
                <div class="row rowphasesMiddle rowphases">
                    <div class="col-lg-12"><h5 class="HeadingCenter">Recruiting Performance Metrics from {{DisplayFilterSDate}} to {{DisplayFilterEDate}}</h5></div>
                    <div class="col-lg-2">
                        <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                            <div class="">
                                <div class="col-auto" style="height:120px;">
                                    <div class="MatrixExportIcon" style="top:0px;" 
                                    v-b-tooltip.hover title="Prospects from a ThirdPool source who entered the database within the selected date range.">
                                    <v-icon name="question"></v-icon>
                                    </div><h6 class="m-b-10">ThirdPool Prospects</h6>
                                    <h2 class="m-b-0 tileNumber" v-if="!showProspectsData"><div class="loader4"></div></h2>
                                    <h2 class="m-b-0 tileNumber" v-if="showProspectsData">{{Phase2ThirdPoolProspectsCount}}</h2>
                                    <download-csv v-if="this.ThirdPoolProspectsCSVList.length" style="margin-left: 10px;"
                                        class="btn-default"
                                        :data="this.ThirdPoolCSVData()"
                                        :name="this.getRPMFileName('ThirdPool-Prospects')"
                                        :fields="reportingFields3"
                                        :labels="reportingLabels3"
                                        >
                                        <div class="MatrixExportIcon"><v-icon name="download"></v-icon></div>
                                    </download-csv>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2">
                        <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                            <div class="">
                                <div class="col-auto" style="height:120px;">
                                    <div class="MatrixExportIcon" style="top:0px;" 
                                    v-b-tooltip.hover title="Prospects from an Organic source who entered the database within the selected date range.">
                                    <v-icon name="question"></v-icon>
                                    </div><h6 class="m-b-10">Organic Prospects</h6>
                                    <h2 class="m-b-0 tileNumber" v-if="!showProspectsData"><div class="loader4"></div></h2>
                                    <h2 class="m-b-0 tileNumber" v-if="showProspectsData">{{this.Phase2OrganicProspectsCount}}</h2>
                                    <download-csv id="1" v-if="this.NotThirdPoolProspectsCSVList.length" style="margin-left: 10px;"
                                        class="btn-default"
                                        :data="this.OrganicCSVData()"
                                        :name="this.getRPMFileName('Organic-Prospects')"
                                        :fields="reportingFields1"
                                        :labels="reportingLabels1"
                                       >
                                        <div class="MatrixExportIcon"><v-icon name="download"></v-icon></div>
                                    </download-csv>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2">
                        <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                            <div class="">
                                <div class="col-auto" style="height:120px;">
                                    <div class="MatrixExportIcon" style="top:0px;" 
                                    v-b-tooltip.hover title="Prospects who were moved to the Pre-Interview Nurture stage within the selected date range.">
                                    <v-icon name="question"></v-icon>
                                    </div>
                                    <h6 class="m-b-10">Pre-Interview Nurture</h6>
                                    <h2 class="m-b-0 tileNumber">{{Phase2PreInterviewNurtureCount}}</h2>
                                    <download-csv v-if="this.PreInterviewNurtureCSVList.length" style="margin-left: 10px;"
                                        class="btn-default"
                                        :data="this.PreInterviewCSVData()"
                                        :name="this.getRPMFileName('Pre-Interview-Nurture')"
                                        :fields="reportingFields5"
                                        :labels="reportingLabels5"
                                        >
                                        <div class="MatrixExportIcon"><v-icon name="download"></v-icon></div>
                                    </download-csv>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2" id="tooltip-target-1">
                        <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                            <div class="">
                                <div class="col-auto" style="height:120px;">
                                    <!-- <div @mouseover="TilesOver('Interviews')" class="MatrixExportIcon" style="top:0px;">
                                    <v-icon name="question"></v-icon>
                                    </div> -->
                                    <div class="MatrixExportIcon" style="top:0px;" 
                                    v-b-tooltip.hover title="Prospects who were Interviewed within the selected date range.">
                                    <v-icon name="question"></v-icon>
                                    </div>
                                    <h6 class="m-b-10">Interviews</h6>
                                    <h2 class="m-b-0 tileNumber">{{Phase2InterviewsCount}}</h2>
                                    <download-csv id="2" v-if="this.InterviewCSVList.length" style="margin-left: 10px;"
                                        class="btn-default"
                                        :data="this.InterviewCSVData()"
                                        :name="this.getRPMFileName('Interviews')"
                                        :fields="reportingFields2"
                                        :labels="reportingLabels2"
                                        >
                                        <div class="MatrixExportIcon"><v-icon name="download"></v-icon></div>
                                    </download-csv>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2"  id="tooltip-target-2">
                        <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                            <div class="">
                                <div class="col-auto" style="height:120px;">
                                    <!-- <div @mouseover="TilesOver('Interview No-Show')" class="MatrixExportIcon" style="top:0px;">
                                    <v-icon name="question"></v-icon>
                                    </div> -->
                                    <div class="MatrixExportIcon" style="top:0px;" 
                                    v-b-tooltip.hover title="Prospects who were Interview No-Show within the selected date range.">
                                    <v-icon name="question"></v-icon>
                                    </div>
                                    <h6 class="m-b-10">Interview No-Show</h6>
                                    <h2 class="m-b-0 tileNumber">{{Phase2InterviewNoShowCount}}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2">
                        <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                            <div class="">
                                <div class="col-auto" style="height:120px;">
                                    <div class="MatrixExportIcon" style="top:0px;" 
                                    v-b-tooltip.hover title="Prospects who were moved to the Post-Interview Nurture stage within the selected date range.">
                                    <v-icon name="question"></v-icon>
                                    </div>
                                    <h6 class="m-b-10">Post-Interview Nurture</h6>
                                    <h2 class="m-b-0 tileNumber">{{Phase2PostInterviewNurtureCount}}</h2>
                                    <download-csv v-if="this.PostInterviewNurtureCSVList.length" style="margin-left: 10px;"
                                        class="btn-default"
                                        :data="this.PostInterviewCSVData()"
                                        :name="this.getRPMFileName('Post-Interview-Nurture')"
                                        :fields="reportingFields6"
                                        :labels="reportingLabels6"
                                        >
                                        <div class="MatrixExportIcon"><v-icon name="download"></v-icon></div>
                                    </download-csv>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2">
                        <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                            <div class="">
                                <div class="col-auto" style="height:120px;">
                                    <div class="MatrixExportIcon" style="top:0px;" 
                                    v-b-tooltip.hover title="Prospects who were moved to the Offer stage within the selected date range.">
                                    <v-icon name="question"></v-icon>
                                    </div>
                                    <h6 class="m-b-10">Offers</h6>
                                    <h2 class="m-b-0 tileNumber">{{Phase2OfferCount}}</h2>
                                    <download-csv v-if="this.OffersCSVList.length" style="margin-left: 10px;"
                                        class="btn-default"
                                        :data="this.OfferCSVData()"
                                        :name="this.getRPMFileName('Offers')"
                                        :fields="reportingFields7"
                                        :labels="reportingLabels7"
                                        >
                                        <div class="MatrixExportIcon"><v-icon name="download"></v-icon></div>
                                    </download-csv>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2" id="tooltip-target-3">
                        <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                            <div class="">
                                <div class="col-auto" style="height:120px;">
                                    <!-- <div @mouseover="TilesOver('Hires')" class="MatrixExportIcon" style="top:0px;">
                                    <v-icon name="question"></v-icon>
                                    </div> -->
                                    <div class="MatrixExportIcon" style="top:0px;" 
                                    v-b-tooltip.hover title="Prospects who were Hired within the selected date range.">
                                    <v-icon name="question"></v-icon>
                                    </div>
                                    <h6 class="m-b-10">Hires</h6>
                                    <h2 class="m-b-0 tileNumber">{{Phase2HiredCount}}</h2>
                                    <download-csv v-if="this.HiresCSVList.length" style="margin-left: 10px;"
                                        class="btn-default"
                                        :data="this.HireCSVData()"
                                        :name="this.getRPMFileName('Hires')"
                                        :fields="reportingFields4"
                                        :labels="reportingLabels4"
                                        >
                                        <div class="MatrixExportIcon"><v-icon name="download"></v-icon></div>
                                    </download-csv>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2" id="tooltip-target-4">
                        <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                            <div class="">
                                <div class="col-auto" style="height:120px;">
                                    <!-- <div @mouseover="TilesOver('Lost to Competitors')" class="MatrixExportIcon" style="top:0px;">
                                    <v-icon name="question"></v-icon>
                                    </div> -->
                                    <div class="MatrixExportIcon" style="top:0px;" 
                                    v-b-tooltip.hover title="Prospects who were moved to the Lost to Competitors stage within the selected date range.">
                                    <v-icon name="question"></v-icon>
                                    </div>
                                    <h6 class="m-b-10">Lost to Competitors</h6>
                                    <h2 class="m-b-0 tileNumber">{{Phase2LosttoCompetitorCount}}</h2>
                                    <download-csv v-if="this.LosttoCompetitorCSVList.length" style="margin-left: 10px;"
                                        class="btn-default"
                                        :data="this.LosttoCompCSVData()"
                                        :name="this.getRPMFileName('Lost-to-Competitors')"
                                        :fields="reportingFields8"
                                        :labels="reportingLabels8"
                                        >
                                        <div class="MatrixExportIcon"><v-icon name="download"></v-icon></div>
                                    </download-csv>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="row rowphases">
                            <div class="col-lg-12"><h5 class="HeadingCenter">Screening Metrics from <br> {{DisplayFilterSDate}} to {{DisplayFilterEDate}}</h5></div>
                            <div class="col-lg-4">
                                <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                                    <div class="">
                                        <div class="col-auto" style="height:120px;">
                                            <div class="MatrixExportIcon" style="top:0px;" 
                                            v-b-tooltip.hover title="Prospects who were “Sent to Manager” within the selected date range. A Prospect who is sent to multiple managers will be counted multiple times.">
                                            <v-icon name="question"></v-icon>
                                            </div>
                                            <h6 class="m-b-10">Prospects Sent to Managers</h6>
                                            <h2 class="m-b-0 tileNumber">{{totalSentProspect}}</h2>
                                            <download-csv v-if="this.totalSentProspect" style="margin-left: 10px;"
                                                class="btn-default"
                                                :data="this.SentProspectCSVData()"
                                                :name="this.getRPMFileName('Prospects-Sent-to-Managers')"
                                                :fields="managerFields"
                                                :labels="managerLabels"
                                                >
                                                <div class="MatrixExportIcon"><v-icon name="download"></v-icon></div>
                                            </download-csv>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                                    <div class="">
                                        <div class="col-auto" style="height:120px;">
                                            <div class="MatrixExportIcon" style="top:0px;" 
                                            v-b-tooltip.hover title="Of the Prospects Sent to a Manager(s), this is the number who were “Reviewed by Manager” using the included review form.">
                                            <v-icon name="question"></v-icon>
                                            </div>
                                            <h6 class="m-b-10">Prospects Reviewed by Managers</h6>
                                            <h2 class="m-b-0 tileNumber">{{totalReviewdProspect}}</h2>
                                            <!-- <h2 class="m-b-0">{{Phase3ProspectsReviewedbyManagersCount}}</h2> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                                    <div class="">
                                        <div class="col-auto" style="height:120px;">
                                            <div class="MatrixExportIcon" style="top:0px;" 
                                            v-b-tooltip.hover title="Of the prospects who were Interviewed, this is the average rating of their interviews. 1=Excellent, 2=Good, 3=Fair, and 4=Poor.">
                                            <v-icon name="question"></v-icon>
                                            </div>
                                            <h6 class="m-b-10">Average Interview Rating</h6>
                                            <h2 class="m-b-0 tileNumber">{{Phase3FinalAverage}}</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="row rowphases">
                            <div class="col-lg-12"><h5 class="HeadingCenter">Messaging Metrics from <br> {{DisplayFilterSDate}} to {{DisplayFilterEDate}}</h5></div>
                            <div class="col-lg-4">
                                <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                                    <div class="">
                                        <div class="col-auto" style="height:120px;">
                                            <div class="MatrixExportIcon" style="top:0px;" 
                                            v-b-tooltip.hover title="The number of Prospects entering the database within the selected date range who received at least one outbound message from the User.">
                                            <v-icon name="question"></v-icon>
                                            </div>
                                            <h6 class="m-b-10">Unique Outbound Messages</h6>
                                            <h2 class="m-b-0 tileNumber" v-if="!isShowConvoAnalytics"><div class="loader4"></div></h2>
                                            <h2 class="m-b-0 tileNumber" v-if="isShowConvoAnalytics">{{totalOutBoundMessageCount}}</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                                    <div class="">
                                        <div class="col-auto" style="height:120px;">
                                            <div class="MatrixExportIcon" style="top:0px;" 
                                            v-b-tooltip.hover title="The number of Prospects entering the database within the selected date range who sent at least one inbound message to the User.">
                                            <v-icon name="question"></v-icon>
                                            </div>
                                            <h6 class="m-b-10">Unique Inbound Messages</h6>
                                            <h2 class="m-b-0 tileNumber" v-if="!isShowConvoAnalytics"><div class="loader4"></div></h2>
                                            <h2 class="m-b-0 tileNumber" v-if="isShowConvoAnalytics">{{totalInboundMessageCount}}</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                                    <div class="">
                                        <div class="col-auto" style="height:120px;">
                                            <div class="MatrixExportIcon" style="top:0px;" 
                                            v-b-tooltip.hover title="Unique Inbound Messages divided by Unique Outbound Messages.">
                                            <v-icon name="question"></v-icon>
                                            </div>
                                            <h6 class="m-b-10">Initial Response Rate</h6>
                                            <h2 class="m-b-0 tileNumber" v-if="!isShowConvoAnalytics"><div class="loader4"></div></h2>
                                            <h2 class="m-b-0 tileNumber" v-if="isShowConvoAnalytics">{{InitialResponseRateCount}}%</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container-fluid mapchartsection" style="min-height: 480px;">
                <div class="row">
                    <div class="col-lg-12">
                        <h5 class="HeadingCenter">Of the {{SourceCount}} prospects added to the database…</h5>
                    </div>
                    <div class="col-lg-8">
                        <div v-if="SourceCount">
                            <div v-if="LoadMapStatus" style="text-align: center; margin-top: 18%; position: absolute; width: 100%; clear: both; z-index: 9;">
                                <b-button variant="outline-primary" @click="ClickOnLoadMap">Load Prospect Map</b-button>
                            </div>
                            <div class="emptyMap" v-if="HideMaps">
                                <div id="map"></div>
                                <div id="distance" class="distance-container"></div>
                            </div>
                            <h2 v-if="!isShowMap" class="m-b-0 text-center loader-blue" style="position: initial;"><div class="loader4"></div></h2>
                        </div>
                        <div v-if="!SourceCount" style="text-align:center;color: #767676;">Sorry, No Map Found.</div>
                    </div>
                    <div class="col-lg-4">
                        <div v-if="SourceCount">
                            <div v-if="!isShowAnalytics" class="col-sm-12 text-center loader-blue" style="position: absolute;padding-left: 0;text-align: left !important; margin-left: auto;">
                                <div class="loader4 "></div>
                            </div>
                            <div v-if="isShowAnalytics" class="first-chart">
                                <apexcharts width="360" height="350" type="bar"  :options="tagChartOptions" :series="tagSeries" style="margin-right:0; margin-left: auto;max-height:200px;min-height: 200px;"></apexcharts>
                                <div><div class='MatrixExportIcon' style='top:0px; color: rgb(255 255 255);background: rgb(144 144 144);height: 27px;padding: 0px 8px;border-radius: 3px;' v-b-tooltip.hover title='A specific breakdown of the current Tags of Prospects who entered the database within the selected date range. '><v-icon name="question"></v-icon></div></div>
                            </div>
                        </div>
                        <div v-if="!SourceCount" style="text-align:center;color: #767676;">Sorry, No Tag Distribution Found.</div>
                    </div>
                </div>
            </div>
            <div class="container-fluid mapchartsection">

                <div class="row">
                    <div class="col-lg-12">
                        <!-- <div class="row chartrow">
                            <div class="col-lg-1"></div>
                            <div class="col-lg-5" style="min-height: 200px;">
                                <div v-if="!isShowAnalytics" class="col-sm-12 text-center loader-blue" style="position: absolute;padding-left: 0;text-align: left !important;">
                                    <div class="loader4 "></div>
                                </div>
                                <div v-if="isShowAnalytics">
                                    <apexcharts width="360" height="200" type="donut" style="max-height:200px;min-height: 200px;" :options="sourceChartOptions" :series="sourceSeries" ></apexcharts>
                                </div>
                            </div>
                            <div class="col-lg-5" style="min-height: 200px;">
                                <div v-if="!isShowAnalytics" class="col-sm-12 text-center loader-blue" style="position: absolute;padding-left: 0;text-align: left !important; margin-left: auto;">
                                        <div class="loader4 "></div>
                                </div>
                                <div v-if="isShowAnalytics" class="first-chart">
                                    <apexcharts width="360" height="200" type="donut"  :options="stageChartOptions" :series="stageSeries" style="margin-right:0; margin-left: auto;max-height:200px;min-height: 200px;"></apexcharts>
                                </div>
                            </div>
                            <div class="col-lg-1"></div>
                        </div> -->
                        <div class="row chartrow">
                            <div class="col-lg-4" style="min-height: 200px;">
                                <div v-if="SourceCount">
                                    <div v-if="!isShowAnalytics" class="col-sm-12 text-center loader-blue" style="position: absolute;padding-left: 0;text-align: left !important;">
                                        <div class="loader4 "></div>
                                    </div>
                                    <div v-if="isShowAnalytics">
                                        <apexcharts width="360" height="200" type="donut" style="max-height:200px;min-height: 200px;" :options="CCIAssessmentChartOptions" :series="cciSeries" ></apexcharts>
                                        <div><div class='MatrixExportIcon' style='top:0px; color: rgb(255 255 255);background: rgb(144 144 144);height: 27px;padding: 0px 8px;border-radius: 3px;' v-b-tooltip.hover title='Percentage of Prospects who entered the database within the selected date range who have completed or not completed the CCI Assessment.'><v-icon name="question"></v-icon></div></div>
                                    </div>
                                </div>
                                <div v-if="!SourceCount" style="text-align:center;color: #767676;">Sorry, No CCI Assessment Completion Found.</div>
                            </div>
                            <div class="col-lg-4" style="min-height: 200px;">
                                <div v-if="SourceCount">
                                    <div v-if="!isShowAnalytics" class="col-sm-12 text-center loader-blue" style="position: absolute;padding-left: 0;text-align: left !important;">
                                        <div class="loader4 "></div>
                                    </div>
                                    <div v-if="isShowAnalytics" class="stageChartStyle">
                                        <apexcharts width="360" height="200" type="donut" style="max-height:200px;min-height: 200px;" :options="sourceChartOptions" :series="sourceSeries" ></apexcharts>
                                        <div><div class='MatrixExportIcon' style='top:0px; color: rgb(255 255 255);background: rgb(144 144 144);height: 27px;padding: 0px 8px;border-radius: 3px;' v-b-tooltip.hover title='A specific breakdown of the Sources of Prospects who entered the database within the selected date range. '><v-icon name="question"></v-icon></div></div>
                                    </div>
                                </div>
                                <div v-if="!SourceCount" style="text-align:center;color: #767676;">Sorry, No Source Distribution Found.</div>
                            </div>
                            <div class="col-lg-4" style="min-height: 200px;">
                                <div v-if="SourceCount">
                                    <div v-if="!isShowAnalytics" class="col-sm-12 text-center loader-blue" style="position: absolute;padding-left: 0;text-align: left !important; margin-left: auto;">
                                            <div class="loader4 "></div>
                                    </div>
                                    <div v-if="isShowAnalytics" class="first-chart stageChartStyle">
                                        <apexcharts width="360" height="200" type="donut"  :options="stageChartOptions" :series="stageSeries" style="margin-right:0; margin-left: auto;max-height:200px;min-height: 200px;"></apexcharts>
                                        <div><div class='MatrixExportIcon' style='top:0px; color: rgb(255 255 255);background: rgb(144 144 144);height: 27px;padding: 0px 8px;border-radius: 3px;' v-b-tooltip.hover title='A specific breakdown of the current Stages of Prospects who entered the database within the selected date range. '><v-icon name="question"></v-icon></div></div>
                                    </div>
                                </div>
                                <div v-if="!SourceCount" style="text-align:center;color: #767676;">Sorry, No Stage Distribution Found.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container-fluid financialshead">
                <div class="row">
                    <div class="col-lg-12"><h5 class="HeadingCenter">Financials</h5></div>
                    <div class="col-lg-12">
                        <div class="financialfiltersection">
                            <div class="financialfilter">
                                <b-form-group label="Month">
                                    <b-form-select v-model="monthFilterValue" :options="monthoptions" 
                                    @change="onChangeMonthFilter($event)" ></b-form-select>
                                    <!-- <div class="mt-2">Selected: <strong>{{ monthFilterValue }}</strong></div> -->
                                </b-form-group>
                            </div>
                            <div class="financialfilter">
                                <b-form-group label="Year">
                                    <b-form-select v-model="yearFilterValue" :options="yearoptions" 
                                    @change="onChangeYearFilter($event)" :disabled="YearFilterDisabled" ></b-form-select>
                                    <!-- <div class="mt-2">Selected: <strong>{{ yearFilterValue }}</strong></div> -->
                                </b-form-group>
                            </div>
                            <!-- <div class="financialfilter">c</div> -->
                        </div>
                    </div>
                    <!-- <div class="col-lg-6"></div> -->
                    <div class="col-lg-12">
                        <div class="row rowphases">
                            <!-- <div class="col-lg-8"></div> -->
                            <div class="col-lg-3">
                                <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                                    <div class="">
                                        <div class="col-auto" style="height:120px;">
                                            <div class="MatrixExportIcon" style="top:0px;" 
                                            v-b-tooltip.hover title="Advertising Costs divided by the number of ThirdPool Prospects who entered the database in the selected month/year.">
                                            <v-icon name="question"></v-icon>
                                            </div>
                                            <h6 class="m-b-10">Ad Cost Per Prospect</h6>
                                            <h2 class="m-b-0">$ {{AdCostPerProspect}}</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="col-lg-8"></div> -->
                            <div class="col-lg-3">
                                <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                                    <div class="">
                                        <div class="col-auto" style="height:120px;">
                                            <div class="MatrixExportIcon" style="top:0px;" 
                                            v-b-tooltip.hover title="Total Costs (not including VRA or other recruiting service subscriptions) divided by the number of Prospects (ThirdPool and Organic) who entered the database in the selected month/year.">
                                            <v-icon name="question"></v-icon>
                                            </div>
                                            <h6 class="m-b-10">Total Cost Per Prospect</h6>
                                            <h2 class="m-b-0">$ {{TotalCostPerProspect}}</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3">
                                <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                                    <div class="">
                                        <div class="col-auto" style="height:120px;">
                                            <div class="MatrixExportIcon" style="top:0px;" 
                                            v-b-tooltip.hover title="Advertising Costs divided by the number of ThirdPool Prospects who were Hired in the selected month/year.">
                                            <v-icon name="question"></v-icon>
                                            </div>
                                            <h6 class="m-b-10">Ad Cost Per Hire</h6>
                                            <h2 class="m-b-0">$ {{AdCostPerHired}}</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3">
                                <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                                    <div class="">
                                        <div class="col-auto" style="height:120px;">
                                            <div class="MatrixExportIcon" style="top:0px;" 
                                            v-b-tooltip.hover title="Total Costs (not including VRA or other recruiting service subscriptions) divided by the number of Prospects (ThirdPool and Organic) who were Hired in the selected month/year.">
                                            <v-icon name="question"></v-icon>
                                            </div>
                                            <h6 class="m-b-10">Total Cost Per Hire</h6>
                                            <h2 class="m-b-0">$ {{TotalCostPerHired}}</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-lg-6">
                        <div class="row rowphases">
                            <div class="col-lg-4">
                                <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                                    <div class="">
                                        <div class="col-auto" style="height:120px;">
                                            <h6 class="m-b-10">Ad Cost Per Hire</h6>
                                            <h2 class="m-b-0">30</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-8"></div>
                            <div class="col-lg-4">
                                <div class="card tatext-card-layout text-c-blue" style="height:120px;">
                                    <div class="">
                                        <div class="col-auto" style="height:120px;">
                                            <h6 class="m-b-10">Total Cost Per Hire</h6>
                                            <h2 class="m-b-0">40</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-8"></div>
                        </div>
                    </div> -->
                </div>
            </div>

            <b-tooltip :target="`tooltip-target-1`" triggers="hover">
                <div>
                    <div style="font-size: 15px;margin-bottom: 12px;font-weight: 600;">Interviews</div>
                    <b-table-simple>
                        <b-thead>
                            <b-tr>
                                <b-th></b-th>
                                <b-th>ThirdPool</b-th>
                                <b-th>Organic</b-th>
                                <b-th>Total</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr>
                                <b-td>Prospects</b-td>
                                <b-td>{{Phase2ThirdPoolProspectsCount}}</b-td>
                                <b-td>{{Phase2OrganicProspectsCount}}</b-td>
                                <b-td>{{SourceCount}}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td>Interviews</b-td>
                                <b-td>{{TilesOverThirdPool('Interviews')}}</b-td>
                                <b-td>{{TilesOverNotThirdPool('Interviews')}}</b-td>
                                <b-td>{{TilesOverThirdPool('Interviews') + TilesOverNotThirdPool('Interviews')}}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td><b>Rate</b></b-td>
                                <b-td><b>{{interviewsRateThirdpool()}}%</b></b-td>
                                <b-td><b>{{interviewsRateOrganic()}}%</b></b-td>
                                <b-td><b>{{interviewsRateTotal()}}%</b></b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </div>
            </b-tooltip>

            <b-tooltip :target="`tooltip-target-2`" triggers="hover">
                <div>
                    <div style="font-size: 15px;margin-bottom: 12px;font-weight: 600;">Interview No-Show</div>
                    <b-table-simple>
                        <b-thead>
                            <b-tr>
                                <b-th></b-th>
                                <b-th>ThirdPool</b-th>
                                <b-th>Organic</b-th>
                                <b-th>Total</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr>
                                <b-td>Scheduled Interviews</b-td>
                                <b-td>{{(TilesOverThirdPool('Interviews') + TilesOverThirdPool('Interview No-Show'))}}</b-td>
                                <b-td>{{(TilesOverNotThirdPool('Interviews') + TilesOverNotThirdPool('Interview No-Show'))}}</b-td>
                                <b-td>{{(TilesOverThirdPool('Interviews') + TilesOverNotThirdPool('Interviews')) + (TilesOverThirdPool('Interview No-Show') + TilesOverNotThirdPool('Interview No-Show'))}}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td>Interview No-Show</b-td>
                                <b-td>{{TilesOverThirdPool('Interview No-Show')}}</b-td>
                                <b-td>{{TilesOverNotThirdPool('Interview No-Show')}}</b-td>
                                <b-td>{{TilesOverThirdPool('Interview No-Show') + TilesOverNotThirdPool('Interview No-Show')}}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td><b>Rate</b></b-td>
                                <b-td><b>{{interviewNoShowRateThirdpool()}}%</b></b-td>
                                <b-td><b>{{interviewNoShowRateOrganic()}}%</b></b-td>
                                <b-td><b>{{interviewNoShowRateTotal()}}%</b></b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </div>
            </b-tooltip>

            <b-tooltip :target="`tooltip-target-3`" triggers="hover">
                <div>
                    <div style="font-size: 15px;margin-bottom: 12px;font-weight: 600;">Hires</div>
                    <b-table-simple>
                        <b-thead>
                            <b-tr>
                                <b-th></b-th>
                                <b-th>ThirdPool</b-th>
                                <b-th>Organic</b-th>
                                <b-th>Total</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr>
                                <b-td>Interviews</b-td>
                                <b-td>{{TilesOverThirdPool('Interviews')}}</b-td>
                                <b-td>{{TilesOverNotThirdPool('Interviews')}}</b-td>
                                <b-td>{{TilesOverThirdPool('Interviews') + TilesOverNotThirdPool('Interviews')}}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td>Hires</b-td>
                                <b-td>{{TilesOverThirdPool('Hires')}}</b-td>
                                <b-td>{{TilesOverNotThirdPool('Hires')}}</b-td>
                                <b-td>{{TilesOverThirdPool('Hires') + TilesOverNotThirdPool('Hires')}}</b-td>
        
                            </b-tr>
                            <b-tr>
                                <b-td><b>Rate</b></b-td>
                                <b-td><b>{{hiresRateThirdpool()}}%</b></b-td>
                                <b-td><b>{{hiresRateOrganic()}}%</b></b-td>
                                <b-td><b>{{hiresRateTotal()}}%</b></b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </div>
            </b-tooltip>

            <b-tooltip :target="`tooltip-target-4`" triggers="hover">
                <div>
                    <div style="font-size: 15px;margin-bottom: 12px;font-weight: 600;">Lost to Competitors</div>
                    <b-table-simple>
                        <b-thead>
                            <b-tr>
                                <b-th></b-th>
                                <b-th>ThirdPool</b-th>
                                <b-th>Organic</b-th>
                                <b-th>Total</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr>
                                <b-td>Interviews</b-td>
                                <b-td>{{TilesOverThirdPool('Interviews')}}</b-td>
                                <b-td>{{TilesOverNotThirdPool('Interviews')}}</b-td>
                                <b-td>{{TilesOverThirdPool('Interviews') + TilesOverNotThirdPool('Interviews')}}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td>Lost to Competitors</b-td>
                                <b-td>{{TilesOverThirdPool('Lost to Competitors')}}</b-td>
                                <b-td>{{TilesOverNotThirdPool('Lost to Competitors')}}</b-td>
                                <b-td>{{TilesOverThirdPool('Lost to Competitors') + TilesOverNotThirdPool('Lost to Competitors')}}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td><b>Rate</b></b-td>
                                <b-td><b>{{lostcompRateThirdpool()}}%</b></b-td>
                                <b-td><b>{{lostcompRateOrganic()}}%</b></b-td>
                                <b-td><b>{{lostcompRateTotal()}}%</b></b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </div>
            </b-tooltip>

            
        </div>
    </section>
</template>  
<script>
import vueMultiSelect from 'vue-multi-select';
import 'vue-multi-select/dist/lib/vue-multi-select.css';
import { db } from 'src/db'
import axios from "axios";
import { mapState } from 'vuex'
// import ApexCharts from 'apexcharts'
import VueApexCharts from 'vue-apexcharts'
import Mapbox from "mapbox-gl";
import * as turf from '@turf/turf'
import moment from 'moment';

	export default {
		name: "ReportingPagev2",
        components: {
            apexcharts: VueApexCharts,
            vueMultiSelect,
        },
		computed: {
            ...mapState('firebase', ['user','prospects', 'convos'])
        },

        mounted() {
            // var chart = new ApexCharts(document.querySelector("#chart"), this.options);
            // chart.render();
        },
        beforeRouteLeave(to, from, next) {
            // eslint-disable-next-line
            console.log('Leaving ReportingPage...');
            this.$store.commit("firebase/SET", {
                var: "convos",
                val: [],
            });
            next();
        },
        created() {
                setTimeout(async() => {
                    if(this.$router.currentRoute.path != '/home/ReportingPage') // 
                    {
                        const now = new Date();
                        const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1).getTime(); // Start of the month
                        const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0).getTime(); // End of the month
                        const conversations = [];
                        const querySnapshot = await db.collection('Conversations')
                            .where('Uid', '==', this.user.Uid)
                            .where('DateUpdated', '>=', startOfMonth)
                            .where('DateUpdated', '<=', endOfMonth)
                            .orderBy('DateUpdated', 'desc')
                            .get();

                        querySnapshot.forEach((doc) => {
                            conversations.push({ id: doc.id, ...doc.data() });
                        });

                        this.$store.commit("firebase/SET", {
                            var: "convos",
                            val: conversations,
                        });
                        this.ReportProspectData = []; // STORE ORIGINAL PROSPECT DATA
                        Object.assign(this.ReportProspectData,this.prospects);
                        
                        this.getReportProspectData = []; // FOR USE REPORTING PURPOSE
                        this.getReportProspectData = this.ReportProspectData;
                        
                        this.startDateendDate();
                        this.getAnalytics();
                        this.newReportVersion();
                        this.commonManageByMonthYear();
                        // this.demoapplyFilter();
                        this.FilterByOfficesManagers();
                        this.isShowH = true;
                    }
                }, 100);
        },
        methods: {
            async fetchConversationsOnDate(uid, startDate, endDate) {
                const startOfMonth = new Date(startDate).getTime();
                const endOfMonth = new Date(endDate).getTime();

                const conversations = [];
                let lastVisible = null;
                const batchSize = 1000;
                
                let continueFetching = true;

                do {
                    let query = db.collection('Conversations')
                        .where('Uid', '==', uid)
                        .where('DateUpdated', '>=', startOfMonth)
                        .where('DateUpdated', '<=', endOfMonth)
                        .orderBy('DateUpdated', 'desc')
                        .limit(batchSize);

                    if (lastVisible) {
                        query = query.startAfter(lastVisible);
                    }

                    const querySnapshot = await query.get();
                    
                    if (querySnapshot.empty) {
                        continueFetching = false;  // Stop the loop if no more documents are found
                    }

                    // Add the fetched documents to the conversations array
                    querySnapshot.forEach((doc) => {
                        conversations.push({ id: doc.id, ...doc.data() });
                    });

                    // Update the last visible document
                    lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];
                    
                    // If the batch is less than the requested size, it means there are no more records
                    if (querySnapshot.docs.length < batchSize) {
                        continueFetching = false;  // Stop the loop if the batch is smaller than expected
                    }
                } while (continueFetching);  // Condition is checked using the flag

                return conversations;
            },
            // INTERVIEWS: RATE THIRDPOOL
            interviewsRateThirdpool() {
                if(this.Phase2ThirdPoolProspectsCount > 0) {
                    return Math.round((this.TilesOverThirdPool('Interviews') / this.Phase2ThirdPoolProspectsCount) * 100);
                } else {
                    return 0;
                }
            },
            // INTERVIEWS: RATE ORGANIC
            interviewsRateOrganic() {
                if(this.Phase2OrganicProspectsCount > 0) {
                    return Math.round((this.TilesOverNotThirdPool('Interviews') / this.Phase2OrganicProspectsCount) * 100);
                } else {
                    return 0;
                }
            },
            // INTERVIEWS: RATE TOTAL
            interviewsRateTotal() {
                var interviewPlus = (this.TilesOverThirdPool('Interviews') + this.TilesOverNotThirdPool('Interviews'));
                if(this.SourceCount > 0) {
                    return Math.round((interviewPlus / this.SourceCount) * 100);
                } else {
                    return 0;
                }
            },
            // INTERVIEW NO SHOW: RATE THIRDPOOL
            interviewNoShowRateThirdpool() {
                var interviewwithnoshowTH = (this.TilesOverThirdPool('Interviews') + this.TilesOverThirdPool('Interview No-Show'));
                if(interviewwithnoshowTH > 0) {
                    return Math.round((this.TilesOverThirdPool('Interview No-Show') / interviewwithnoshowTH) * 100);
                } else {
                    return 0;
                }
            },
            // INTERVIEW NO SHOW: RATE ORGANIC
            interviewNoShowRateOrganic() {
                var interviewwithnoshowNotTH = (this.TilesOverNotThirdPool('Interviews') + this.TilesOverNotThirdPool('Interview No-Show'));
                if(interviewwithnoshowNotTH > 0) {
                    return Math.round((this.TilesOverNotThirdPool('Interview No-Show') / interviewwithnoshowNotTH) * 100);
                } else {
                    return 0;
                }
            },
            // INTERVIEW NO SHOW: RATE TOTAL
            interviewNoShowRateTotal() {
                var iandinsPlus = (this.TilesOverThirdPool('Interviews') + this.TilesOverNotThirdPool('Interviews')) + (this.TilesOverThirdPool('Interview No-Show') + this.TilesOverNotThirdPool('Interview No-Show'));
                if(iandinsPlus > 0) {
                    return Math.round(((this.TilesOverThirdPool('Interview No-Show') + this.TilesOverNotThirdPool('Interview No-Show')) / (iandinsPlus)) * 100);
                } else {
                    return 0;
                }
            },
            // HIRES: RATE THIRDPOOL
            hiresRateThirdpool() {
                if(this.TilesOverThirdPool('Interviews') > 0) {
                    return Math.round((this.TilesOverThirdPool('Hires') / this.TilesOverThirdPool('Interviews')) * 100);
                } else {
                    return 0;
                }
            },
            // HIRES: RATE ORGANIC
            hiresRateOrganic() {
                if(this.TilesOverNotThirdPool('Interviews') > 0) {
                    return Math.round((this.TilesOverNotThirdPool('Hires') / this.TilesOverNotThirdPool('Interviews')) * 100);
                } else {
                    return 0;
                }
            },
            // HIRES: RATE TOTAL
            hiresRateTotal() {
                var interviewPlus = (this.TilesOverThirdPool('Interviews') + this.TilesOverNotThirdPool('Interviews'));
                var hiresPlus = (this.TilesOverThirdPool('Hires') + this.TilesOverNotThirdPool('Hires'));
                if(interviewPlus > 0) {
                    return Math.round((hiresPlus / interviewPlus) * 100);
                } else {
                    return 0;
                }
            },
            // LOST TO COMPETITORS: RATE THIRDPOOL
            lostcompRateThirdpool() {
                if(this.TilesOverThirdPool('Interviews') > 0) {
                    return Math.round((this.TilesOverThirdPool('Lost to Competitors') / this.TilesOverThirdPool('Interviews')) * 100);
                } else {
                    return 0;
                }
            },
            // LOST TO COMPETITORS: RATE ORGANIC
            lostcompRateOrganic() {
                if(this.TilesOverNotThirdPool('Interviews') > 0) {
                    return Math.round((this.TilesOverNotThirdPool('Lost to Competitors') / this.TilesOverNotThirdPool('Interviews')) * 100);
                } else {
                    return 0;
                }
            },
            // LOST TO COMPETITORS: RATE TOTAL
            lostcompRateTotal() {
                var interviewPlus = (this.TilesOverThirdPool('Interviews') + this.TilesOverNotThirdPool('Interviews'));
                var lostcompPlus = (this.TilesOverThirdPool('Lost to Competitors') + this.TilesOverNotThirdPool('Lost to Competitors'));
                if(interviewPlus > 0) {
                    return Math.round((lostcompPlus / interviewPlus) * 100);
                } else {
                    return 0;
                }
            },
            // MANAGE COUNT ACCORDING TO TILES LABELS (THIRDPOOL)
            TilesOverThirdPool(getName) {
                var thValue;
                if(getName == 'Interviews') {
                    thValue = this.InterviewedTileThirdPoolProspectsCount;
                } else if (getName == 'Interview No-Show') {
                    thValue = this.InterviewNoShowTileThirdPoolProspectsCount;
                } else if (getName == 'Hires') {
                    thValue = this.HiredTileThirdPoolProspectsCount;
                } else if (getName == 'Lost to Competitors') {
                    thValue = this.LostToCompetitorTileThirdPoolProspectsCount;
                }
                return thValue;
            },
            // MANAGE COUNT ACCORDING TO TILES LABELS (ORGANIC)
            TilesOverNotThirdPool(getName) {
                var notthValue;
                if(getName == 'Interviews') {
                    notthValue = this.InterviewedTileOrganicProspectsCount;
                } else if (getName == 'Interview No-Show') {
                    notthValue = this.InterviewNoShowTileOrganicProspectsCount;
                } else if (getName == 'Hires') {
                    notthValue = this.HiredTileOrganicProspectsCount;
                } else if (getName == 'Lost to Competitors') {
                    notthValue = this.LostToCompetitorTileOrganicProspectsCount;
                }
                return notthValue;
            },
            // TILES CUSTOM POPUP MANAGE
            TilesOver(titleName){
                this.storeTempTileName = titleName;
                // this.$bvModal.show(`TilesOver${titleName}`); 
            },
            ClickOnLoadMap() {
                this.HideMaps = true;
                this.LoadMapStatus = false;
                setTimeout(() => {
                    this.bindMap();
                }, 100);
            },
            startDateendDate()
            {
                this.startDate = moment(this.form.s_date).valueOf();
                this.endDate = moment(this.form.e_date).set({ hour: 23, minute: 59, second: 59, millisecond: 999 }).valueOf();

                this.DisplayFilterSDate = moment(this.form.s_date).format('MMMM DD, YYYY'); // February 1, 2022
                this.DisplayFilterEDate = moment(this.form.e_date).format('MMMM DD, YYYY');

                this.TodaysDate = moment(new Date()).format('MMMM DD, YYYY');
            },
            // FINANCIALS > MONTH FILTER
            onChangeMonthFilter(event)
            {
                this.YearFilterDisabled = false; // DISABLE YEAR DROPDOWN
                this.monthFilterValue = event; // STORE MONTH VALUE
                if(event == 'All') {
                    this.MonthYear = this.yearFilterValue+'Total';
                    this.maintainAllflag = 1;
                } else {
                    this.MonthYear = this.monthFilterValue+''+this.yearFilterValue;
                    this.maintainAllflag = 0;
                }
                this.commonManageByMonthYear();
                // eslint-disable-next-line
                //console.log('Year: ', this.MonthYear);
            },
            // FINANCIALS > YEAR FILTER
            onChangeYearFilter(event)
            {
                this.yearFilterValue = event; // STORE YEAR VALUE
                if(this.maintainAllflag == 1) {
                    this.MonthYear = this.yearFilterValue+'Total';
                } else {
                    this.MonthYear = this.monthFilterValue+''+this.yearFilterValue;
                }
                this.commonManageByMonthYear();
                // eslint-disable-next-line
                //console.log('Year: ', this.MonthYear);
            },
            // CONVERT NAME TO NUMBER
            convertMonthName(month)
            {
                if(month == 'January') { return 0; } 
                else if (month == 'February') { return 1; } 
                else if (month == 'March') { return 2; } 
                else if (month == 'April') { return 3; } 
                else if (month == 'May') { return 4; } 
                else if (month == 'June') { return 5; } 
                else if (month == 'July') { return 6; } 
                else if (month == 'August') { return 7; } 
                else if (month == 'September') { return 8; } 
                else if (month == 'October') { return 9; } 
                else if (month == 'November') { return 10; } 
                else if (month == 'December') { return 11; }
            },
            commonManageByMonthYear()
            {
                if(this.monthFilterValue == 'All') {
                    var FirstDayOfYearWords = new Date(this.yearFilterValue, 0, 1); // Tue Jan 01 2022 00:00:00 GMT+0530 (India Standard Time)
                    var LastDayOfYearWords = new Date(this.yearFilterValue, 12, 0); // Tue Dec 31 2022 00:00:00 GMT+0530 (India Standard Time)
                    this.financeLogic(FirstDayOfYearWords, LastDayOfYearWords)
                } else {
                    let getMonthNumber = this.convertMonthName(this.monthFilterValue);
                    var FirstDayOfMonthWords = new Date(this.yearFilterValue, getMonthNumber, 1); // Tue Feb 01 2022 00:00:00 GMT+0530 (India Standard Time)
                    var LastDayOfMonthWords = new Date(this.yearFilterValue, getMonthNumber + 1, 0); // Tue Feb 28 2022 00:00:00 GMT+0530 (India Standard Time)
                    this.financeLogic(FirstDayOfMonthWords, LastDayOfMonthWords)
                }
            },
            // FINANCE KEY MANAGE
            keyManageByFinance(keyy)
            {
                var keymanage;
                if(this.maintainAllflag == 1) {
                    keymanage = this.MonthYear+''+keyy;
                } else {
                   keymanage = this.MonthYear;
                }
                return keymanage;
            },
            financeLogic(FirstDayOfMonthWords, LastDayOfMonthWords)
            {
                var FirstDayOfMonth = moment(FirstDayOfMonthWords).valueOf();
                var LastDayOfMonth = moment(LastDayOfMonthWords).set({ hour: 23, minute: 59, second: 59, millisecond: 999 }).valueOf();
                
                // var FirstDayOfMonth = new Date(FirstDayOfMonthWords).setHours(0,0,0,0) + (3600000*5.5); // 14345364645745
                // var LastDayOfMonth = new Date(LastDayOfMonthWords).setHours(23,59,59,999); // 14345364645745

                this.userData = [];
                Object.assign(this.userData,this.user);

                if (this.ReportProspectData) 
                {
                    // AD COST PER PROSPECT
                    let AdCostPerProspectData = this.ReportProspectData.filter(rp => rp.DateCreated >= FirstDayOfMonth && rp.DateCreated <= LastDayOfMonth && rp.Source == "ThirdPool Ad");
                    if(AdCostPerProspectData.length) {
                        if(this.userData.MonthlyAdCost) {
                            var one1 = this.keyManageByFinance('Ad');
                            var costValue1 = this.userData.MonthlyAdCost[one1];
                            if(costValue1) {
                                var AdCostValue = costValue1.replace(',',''); // GET DYNAMIC VALUE ACCORDING TO MONTH YEAR FILTER
                                this.AdCostPerProspect = (AdCostValue / AdCostPerProspectData.length).toFixed(2); // Ad Cost Per Prospect
                            }
                        }
                    } else {
                        this.AdCostPerProspect = 0;
                    }
                    
                    // TOTAL COST PER PROSPECT
                    let TotalCostPerProspectData = this.ReportProspectData.filter(rp => rp.DateCreated >= FirstDayOfMonth && rp.DateCreated <= LastDayOfMonth && (!rp.hasOwnProperty('Source') || rp.Source != ""));
                    if(TotalCostPerProspectData.length) {
                        if(this.userData.MonthlyTotalCost) {
                            var two2 = this.keyManageByFinance('Cost');
                            var costValue2 = this.userData.MonthlyTotalCost[two2];
                            if(costValue2) {
                                var TotalCostValue = costValue2.replace(',',''); // GET DYNAMIC VALUE ACCORDING TO MONTH YEAR FILTER
                                this.TotalCostPerProspect = (TotalCostValue / TotalCostPerProspectData.length).toFixed(2); // TOTAL Cost Per Prospect
                            }
                        }
                    } else {
                        this.TotalCostPerProspect = 0;
                    }
                    
                    // AD COST PER HIRE
                    let AdCostPerHireData = this.ReportProspectData.filter(rp => rp.Hired >= FirstDayOfMonth && rp.Hired <= LastDayOfMonth && rp.Source && rp.Source == "ThirdPool Ad");
                    if(AdCostPerHireData.length) {
                        if(this.userData.MonthlyAdCost) {
                            var two3 = this.keyManageByFinance('Ad');
                            var costValue3 = this.userData.MonthlyAdCost[two3];
                            if(costValue3) {
                                var AdCostHireValue = costValue3.replace(',',''); // GET DYNAMIC VALUE ACCORDING TO MONTH YEAR FILTER
                                this.AdCostPerHired = (AdCostHireValue / AdCostPerHireData.length).toFixed(2); // Ad Cost Per HIRE
                            }
                        }
                     } else {
                        this.AdCostPerHired = 0;
                    }

                    // TOTAL COST PER HIRE
                    let TotalCostPerHireData = this.ReportProspectData.filter(rp => rp.Hired >= FirstDayOfMonth && rp.Hired <= LastDayOfMonth && (!rp.hasOwnProperty('Source') || rp.Source != ""));
                    if(TotalCostPerHireData.length) {
                        if(this.userData.MonthlyTotalCost) {
                            var two4 = this.keyManageByFinance('Cost');
                            var costValue4 = this.userData.MonthlyTotalCost[two4];
                            if(costValue4) {
                                var TotalCostHireValue = costValue4.replace(',',''); // GET DYNAMIC VALUE ACCORDING TO MONTH YEAR FILTER
                                this.TotalCostPerHired = (TotalCostHireValue / TotalCostPerHireData.length).toFixed(2); // Total Cost Per Hire
                            }
                        }
                    } else {
                        this.TotalCostPerHired = 0;
                    }
                }
            },
            // DISPLAY FILTER BY COUNT
            CheckboxLabel() {
                return 'Filter By ('+this.FilterByCount+')';
            },
            // CHART
            async getAnalytics() {

                this.dateRangeProspect = [];
                // let dateRangeCreatedTask = []
                // let dateRangeCompeletedTask = [];
                let sourceArray = [];
                
               
                this.totalProspect = 0;
                this.totalCreatedTask = 0;
                this.totalCompeletedTask = 0;
                this.totalInboundMessage = 0;
                this.totalOutBoundMessage = 0;
                this.totalResonseRate = 0;

                this.stageChartOptions.labels = [];
                var stages = [];
                Object.assign(stages,this.user.Stages) ;
                // this.stageChartOptions.labels = stages
                // stages.push('Uncategorized','Archived');
                stages.push('Archived');
                // this.stageChartOptions.labels.push('Uncategorized','Archived');
                this.stageChartOptions.labels = stages;
                this.stageChartOptions.labels = this.stageChartOptions.labels.filter((item, i, ar) => ar.indexOf(item) === i);
                this.isShowTagAnalytics = false;
                this.tagChartOptions.xaxis.categories = [];
                this.tagChartOptions.xaxis.categories = this.user.Folders;
                // this.tagSeries[0].data = [];
                this.tagSeries = [{
                    name:'Tag Distribution',
                    data: []
                }];
                // eslint-disable-next-line
                // console.log('this.user.Folders', this.user.Folders);
                // eslint-disable-next-line
                // console.log('this.user', this.user);
                if (this.user.Folders && this.user.Folders.length) {
                    for(let f of this.user.Folders) {
                        let count = 0;
                        // if (this.getReportProspectData && this.getReportProspectData.length) {
                        if (this.getReportProspectData) {
                        // if (this.prospects && this.prospects.length) {
                            for(let p of this.getReportProspectData) {
                                if ((p.DateCreated >= this.startDate && p.DateCreated <= this.endDate)) {
                                    // eslint-disable-next-line
                                    // console.log('p.Tags', p.Tags);
                                    if (p.Tags && p.Tags.length ) {
                                        if (p.Tags.indexOf(f) > -1) {
                                            count++;
                                        }
                                    }
                                    
                                }
                            }
                        }
                        
                        this.tagSeries[0].data.push(count);   
                        // eslint-disable-next-line
                        // console.log('count', count);
                        // eslint-disable-next-line
                        // console.log('this.tagSeries', this.tagSeries);
                    }
                    this.isShowTagAnalytics = true;
                }
                else {
                    this.isShowTagAnalytics = true;
                }
                
                // if(this.getReportProspectData.length) {
                if(this.getReportProspectData) {
                    for(let p of this.getReportProspectData) {
                        if ((p.DateCreated >= this.startDate && p.DateCreated <= this.endDate)) {

                            this.dateRangeProspect.push(p);
                            this.totalProspect = this.totalProspect+1;
                            if(p.hasOwnProperty('Source') && p.Source) {
                                sourceArray.push(p.Source);
                            }
                            
                            // for(let source of this.sourceChartOptions.labels) {
                            //     let s = this.dateRangeProspect.filter(pr =>  pr.Source == source);
                            //     this.sourceSeries.push(s.length)
                            // }
                        }
                        if (p.Tasks) {
                            for(let t of p.Tasks) {
                                if ((t.CreatedOn >= this.startDate && t.CreatedOn <= this.endDate)) {
                                    // dateRangeCreatedTask.push(t);
                                    this.totalCreatedTask = this.totalCreatedTask+1;
                                }
                                if (t.CompletedOn && (t.CompletedOn >= this.startDate && t.CompletedOn <= this.endDate)){
                                    // dateRangeCompeletedTask.push(t);
                                    this.totalCompeletedTask = this.totalCompeletedTask+1;
                                }
                            }
                        }
                    }
                    this.showProspectAnalytics = true;
                } else {
                    this.showProspectAnalytics = true;
                }
                // let mesRef = await db.collectionGroup('Messages').where('Body', '==', 'Helllooo 123').get();
                // let messageList = mesRef.docs.map((doc) => {
                //                         let data = {...doc.data() };
                //                         return data;
                //                 })
                // var museums = db.collectionGroup('Messages').where('Body', '==', 'Helllooo 123');
                // museums.get().then((querySnapshot) => {
                //     querySnapshot.forEach((doc) => {
                //         //eslint-disable-next-line
                //         console.log(doc.id, ' => ', doc.data());
                //     });
                // });
                // 9OK5P3DhFUckJaSJFq9a
                // let mesRef = await db.collection(`Conversations/{id}/Messages`).get();
                // let messageList = mesRef.docs.map((doc) => {
                //             let data = {...doc.data() };
                //             return data;
                //         });
                // eslint-disable-next-line
                // console.log('this.convos', this.convos);

                /*if (this.convos.length) {
                    for (let c of this.convos) {
                        if (c.DateUpdated && (c.DateUpdated >= this.startDate && c.DateUpdated <= this.endDate)) {
                            let mesRef = await db.collection(`Conversations/${c.id}/Messages`).get();
                                // let messageList = mesRef.docs.map((doc) => {
                                mesRef.docs.map((doc) => {
                                let data = {...doc.data() };
                                return data;
                            })
                            // eslint-disable-next-line
                            // console.log('messageList ',messageList);
                            // if (messageList.length) {
                            //     for (let m of messageList) {
                            //         if (m.Date && (m.Date >= this.startDate && m.Date <= this.endDate)){
                            //             if (m.Inbound) {
                            //                 this.totalInboundMessage = this.totalInboundMessage+1;
                            //             }else {
                            //                 this.totalOutBoundMessage = this.totalOutBoundMessage+1;
                            //             }
                            //         }
                            //     }
                            // }
                        }
                        
                    }
                    // if (this.totalInboundMessage && this.totalOutBoundMessage) {
                    //     this.totalResonseRate = ((this.totalInboundMessage / this.totalOutBoundMessage)*100).toFixed(2);
                    //     this.totalResonseRate = Math.round(this.totalResonseRate);
                    // }
                    // this.isShowConvoAnalytics = true;
                }else {
                    // this.isShowConvoAnalytics = true;
                }*/
                
                
                // make unique value array
                sourceArray = sourceArray.filter((item, i, ar) => ar.indexOf(item) === i);
               
                this.sourceChartOptions.labels = [];
                this.sourceChartOptions.labels = sourceArray;

                //eslint-disable-next-line
                // console.log('sourceArray', sourceArray);  

                // if (this.dateRangeProspect.length) {
                if (this.dateRangeProspect) {
                    this.stageSeries = [];
                    this.sourceSeries = [];
                    
                    for(let stage of this.stageChartOptions.labels) {
                        // if (stage == 'Uncategorized') {
                        //     let s = this.dateRangeProspect.filter(pr =>  (pr.Status == stage || pr.Status == null));
                        //     this.stageSeries.push(s.length)
                        // }else {
                            let s = this.dateRangeProspect.filter(pr =>  pr.Status == stage);
                            this.stageSeries.push(s.length)
                            
                        // }
                        
                    }


                    for(let source of this.sourceChartOptions.labels) {
                        let s = this.dateRangeProspect.filter(pr =>  pr.Source == source);
                        this.sourceSeries.push(s.length)
                    }

                    this.isShowAnalytics = true;
                   
                }else {
                    this.isShowAnalytics = true;
                }
                this.disabledStatus=false;
            },
            async applyFilter() {

                this.disabledStatus=true;
                this.$store.commit("firebase/SET", {
                    var: "convos",
                    val: [],
                })
                
                const fetchData = await this.fetchConversationsOnDate(this.user.Uid, this.form.date_s, this.form.date_e);

                //eslint-disable-next-line
                console.log('fetchData', fetchData);
                if(fetchData && fetchData.length > 0) {
                    this.$store.commit("firebase/SET", {
                        var: "convos",
                        val: fetchData,
                    });
                }

                // this.map.remove();
                if (this.isShowAnalytics && this.isShowConvoAnalytics && this.showProspectAnalytics && this.isShowTagAnalytics && this.showProspectsData && this.isShowMap) {
                    this.isShowMap = false;
                    this.downloadCount = 0;
                    this.OrganicCSVDownloadCount = 0;
                    this.InterviewCSVDownloadCount = 0;
                    this.ThirdPoolCSVDownloadCount = 0;
                    this.HireCSVDownloadCount = 0;
                    this.PreInterviewCSVDownloadCoun = 0;
                    this.PostInterviewCSVDownloadCount = 0;
                    this.OfferCSVDownloadCount = 0;
                    this.LostToCompCSVDownloadCount = 0;
                    this.SentProspectManagerCSVDownloadCount = 0;

                    this.form.s_date = this.form.date_s;
                    this.form.e_date = this.form.date_e;
                    this.isShowAnalytics = false;
                    this.isShowTagAnalytics = false;
                    // this.showProspectAnalytics = false;
                    this.showProspectsData = false;
                    
                    this.startDateendDate();
                    this.newReportVersion();
                    this.getAnalytics();
                    // this.demoapplyFilter();
                    this.HideMaps = false;

                }
            },
            async GoogleMapLoad(){
                const uniqueIDArray = new Set();
                
                for (const o of this.getReportProspectData) {
                    if(o.DateCreated && (o.DateCreated >= this.startDate && o.DateCreated <= this.endDate)) {
                        if(o.Zip != '' && typeof o.Zip !== 'undefined') {
                            uniqueIDArray.add(o.Zip);
                        }
                    }
                }
                
                for(const p of uniqueIDArray) {
                    await axios.get("https://maps.googleapis.com/maps/api/geocode/json?address="+p+"&key=AIzaSyDB3iBxxzF9leRLy4mihVjBCAwWFenuuuA")
                    .then(response => {
                        
                        /*if(response.status == 'OK' || response.status == '200') {
                            if (response.data.results && response.data.results.length > 0) {
                                this.prospMapDetailArray.push({
                                    lng:response.data.results[0].geometry.location.lng,
                                    lat:response.data.results[0].geometry.location.lat,
                                    pid:p
                                })
                            }
                        }*/

                        if(response.status == 200 && response.hasOwnProperty('data') && Object.keys(response.data.results).length) {
                            let results = response.data.results;
                            let isFound = 0;
                            for (let i = 0; i < results.length; i++) {
                                for (let j = 0; j < results[i].address_components.length; j++) {
                                    if (results[i].address_components[j].types[0]=='country') {
                                        if (results[i].address_components[j].short_name == 'US') {
                                            isFound = 1;
                                            this.googlelat = response.data.results[i].geometry.location.lat;
                                            this.googlelng = response.data.results[i].geometry.location.lng;
                                            break;
                                        } else if (results[i].address_components[j].short_name == 'CA') {
                                            isFound = 2;
                                            this.googlelat = response.data.results[i].geometry.location.lat;
                                            this.googlelng = response.data.results[i].geometry.location.lng;
                                            break;
                                        }
                                    }
                                }
                            }
                            if (isFound == 0) {
                                this.googlelat = response.data.results[0].geometry.location.lat;
                                this.googlelng = response.data.results[0].geometry.location.lng;
                            }
                        }

                        this.prospMapDetailArray.push({
                            lng:this.googlelng,
                            lat:this.googlelat,
                            pid:p
                        })

                    });
                }

                if(this.SourceCount > 0) {
                    this.LoadMapStatus = true;
                    this.HideMaps = true;
                    // this.bindMap();
                    //eslint-disable-next-line
                    //console.log('Load Prospect Map...');
                }
            },
            bindMap() {
                this.map = new this.mapbox.Map({
					container: 'map', // container id
					style: 'mapbox://styles/mapbox/streets-v11', // style URL
					center: this.coordinates, // starting position [lng, lat]
					zoom: 1, // starting zoom
				})
                var map = this.map;
                var nav = new this.mapbox.NavigationControl();
                map.addControl(nav, 'top-left');
				map.addControl(new this.mapbox.FullscreenControl());
				var scale = new this.mapbox.ScaleControl({
					maxWidth: 200,
					unit: 'imperial'
				});
				map.addControl(scale);
				scale.setUnit('imperial');

                
                this.prospMapDetailArray.forEach(element3 => {
                    this.NumberOfMapPros = 0;
                    /*
                    new this.mapbox.Marker({anchor: "center", color: "blue"})
                    .setLngLat([element3.lng,element3.lat])
                    .setPopup(new this.mapbox.Popup().setHTML(this.NumberOfMapProsCount(element3.pid)))
                    .addTo(map);
                    */
                    var popup = new this.mapbox.Popup().setHTML(this.NumberOfMapProsCount(element3.pid));
                    // create the marker
                    let marker = new this.mapbox.Marker({anchor: "center", color: "blue"}).setLngLat([element3.lng,element3.lat]);
                    // get the marker element
                    const element = marker.getElement();
                    // hover event listener
                    element.addEventListener('mouseenter', () => popup.addTo(map));
                    element.addEventListener('mouseleave', () => popup.remove());
                    // add popup to marker
                    marker.setPopup(popup);
                    // add marker to map
                    marker.addTo(map);
                });
                

                var distanceContainer = document.getElementById('distance');
                var geojson = {
					'type': 'FeatureCollection',
					'features': []
				};
                var linestring = {
					'type': 'Feature',
					'geometry': {
						'type': 'LineString',
						'coordinates': []
					}
				};
                map.on('load', function () {
                    map.addSource('geojson', {'type': 'geojson','data': geojson});	
                    map.addLayer({
                        id: 'measure-points',
                        type: 'circle',
                        source: 'geojson',
                        paint: {
                            'circle-radius': 5,
                            'circle-color': '#000'
                        },
                        filter: ['in', '$type', 'Point']
                    });
                    map.addLayer({
                        id: 'measure-lines',
                        type: 'line',
                        source: 'geojson',
                        layout: {
                            'line-cap': 'round',
                            'line-join': 'round'
                        },
                        paint: {
                            'line-color': '#000',
                            'line-width': 2.5
                        },
                        filter: ['in', '$type', 'LineString']
                    });
                    map.on('click', function (e) {
                        //eslint-disable-next-line
                        // console.log('Map click fire');
                        var features = map.queryRenderedFeatures(e.point, {
                            layers: ['measure-points']
                        });

                        // Remove the linestring from the group
                        // So we can redraw it based on the points collection
                        if (geojson.features.length > 1) geojson.features.pop();

                        // Clear the Distance container to populate it with a new value
                        distanceContainer.innerHTML = '';

                        // If a feature was clicked, remove it from the map
                        if (features.length) {
                            var id = features[0].properties.id;
                            geojson.features = geojson.features.filter(function (point) {
                                return point.properties.id !== id;
                            });
                        } else {
                            var point = {
                                'type': 'Feature',
                                'geometry': {
                                    'type': 'Point',
                                    'coordinates': [e.lngLat.lng, e.lngLat.lat]
                                },
                                'properties': {
                                    'id': String(new Date().getTime())
                                }
                            };
                            geojson.features.push(point);
                        }
                        if (geojson.features.length > 1) {
                            linestring.geometry.coordinates = geojson.features.map(
                            function (point) {
                                return point.geometry.coordinates;
                            });

                            geojson.features.push(linestring);

                            // Populate the distanceContainer with total distance
                            var value = document.createElement('pre');
                            value.textContent = 'Total distance: ' + turf.length(linestring).toLocaleString() + ' mi';
                            distanceContainer.appendChild(value);
                        }
                        map.getSource('geojson').setData(geojson);
                    });

                    map.on('mousemove', function (e) {
                        var features = map.queryRenderedFeatures(e.point, {
                            layers: ['measure-points']
                        });
                        // UI indicator for clicking/hovering a point on the map
                        map.getCanvas().style.cursor = features.length
                            ? 'pointer'
                            : 'crosshair';
                    });
                });	
                this.isShowMap = true;
            },
            NumberOfMapProsCount(element3pid) {
                this.mapnameglobal = [];
                var displayTitleProspect;
                this.getReportProspectData.forEach(proselement => {
                    if(proselement.DateCreated && (proselement.DateCreated >= this.startDate && proselement.DateCreated <= this.endDate)) {
                        if(proselement.Zip != '' && typeof proselement.Zip !== 'undefined') {
                            if(proselement.Zip == element3pid) {
                                this.NumberOfMapPros = this.NumberOfMapPros + 1;
                                this.mapnameglobal.push(proselement.First+' '+proselement.Last);
                                if(this.NumberOfMapPros > 1) { displayTitleProspect = 'Prospects: '; } else { displayTitleProspect = 'Prospect: '; }
                            }
                        }
                    }
                });
                return '<b>'+this.NumberOfMapPros+' '+displayTitleProspect+'</b> <br>'+this.mapMarkerProspectName();
            },
            // DISPLAY NAME IN MAP MARKER 
            mapMarkerProspectName() {
                var tablestart = '<table><tbody>';
                var tablemiddle = [];
                for(var i=0; i<this.mapnameglobal.length; i++) {
                    tablemiddle = '<tr><td>' +(i+1)+') '+this.mapnameglobal[i]+'</td></tr>';
                    tablestart = tablestart+''+tablemiddle;
                }
                var tableend = '</tbody></table>';
                var tabledisplay = tablestart+''+tableend;
                return tabledisplay;
            },
            
            filterByDataManage()
            {
                if(this.array2 && this.array2.length) {  // 76, 86.... get manager id
                    this.array2.forEach(ma => {
                        var getOfficeData = this.user.Offices.filter(uo => uo.MgrID == ma); // find office id according manager id
                        this.array3.push(getOfficeData); // 76 array(3), 86 array(3)....
                        this.array3MergeData = [].concat.apply([], this.array3); // array(10) offices get according manager
                    });
                }
                if(this.array2.length == 0) { 
                    this.array3MergeData = []; 
                }
                this.StoreManagersOfficeId = [];
                this.array3MergeData.forEach(me => {
                    this.StoreManagersOfficeId.push(me.OfficeId);
                });
                const MergeOfficesManagersOfficeId = this.StoreManagersOfficeId.concat(this.array1);
                let getuniqueofficeid = [...new Set(MergeOfficesManagersOfficeId)];
                getuniqueofficeid.forEach(elementtest => {
                    let FilterByGetData = this.ReportProspectData.filter(ps => ps.Office == elementtest);
                    if(FilterByGetData != '' && typeof FilterByGetData !== 'undefined') {
                        this.FilterReportProspectData.push(FilterByGetData);
                    }
                });
                if (this.FilterByCount != 0) {
                    const MergeOfficesManagersOfficeId1 = [].concat.apply([], this.FilterReportProspectData.concat(this.Tone));
                    let getuniqueofficeid1 = [...new Set(MergeOfficesManagersOfficeId1)];
                    this.getReportProspectData = getuniqueofficeid1;
                } else {
                    this.getReportProspectData = this.ReportProspectData;
                }
            },
            newReportVersion()
            {
                this.initResetValues();
               
                this.filterByDataManage();

                this.RecruitingPipeline();

                // if (this.getReportProspectData && this.getReportProspectData.length) {
                if (this.getReportProspectData) {
                    this.getReportProspectData.forEach(element => {
                        if(element.DateCreated && (element.DateCreated >= this.startDate && element.DateCreated <= this.endDate)) 
                        {
                            
                            if(element.Source) {
                                // THIRDPOOL AD
                                if(element.Source == "ThirdPool Ad") {
                                    this.ThirdPoolProspectsCSVList.push(element);
                                    this.Phase2ThirdPoolProspectsCount  = this.Phase2ThirdPoolProspectsCount + 1;
                                }
                            }
                            // NOT THIRDPOOL AD
                            if(!element.hasOwnProperty('Source') || element.Source != "ThirdPool Ad") {
                                this.NotThirdPoolProspectsCSVList.push(element);
                                this.Phase2OrganicProspectsCount = this.Phase2OrganicProspectsCount + 1;

                                //eslint-disable-next-line
                                // console.log('not thirdpool ad',element);
                            }
                            // MAP HEADING
                            if(!element.hasOwnProperty('Source') || element.Source != "") {
                                this.SourceCount = this.SourceCount + 1;
                            }

                            // COUNT CCI CHART DATA
                            if(element.CciMap != null && element.CciMap !== 'undefined') {
                                if(element.CciMap.DateSubmitted != 0 && element.CciMap.DateSubmitted != '') {
                                    this.CCICount = this.CCICount + 1;
                                }
                            }

                            this.Phase4OutboundStep1 = element.Number; // +12069308608
                            this.convos.forEach(elementconvos => {
                                if(elementconvos.ClientNumber == this.Phase4OutboundStep1) {
                                    this.CalculateInboundOutbound(elementconvos.id);
                                }
                            });
                        }

                        // PROJECTED HIRES 
                        if(element.Hired != "" && typeof element.Hired !== 'undefined') {
                            var CurrentDateOne = new Date(); // CURRENT DATE
                            var CurrentDateTwo = CurrentDateOne.getFullYear(); // CURRENT YEAR
                            var CurrentDateThree = new Date('01 Jan '+CurrentDateTwo+''); // 1st JAN CURRENT YEAR 
                            if(element.Hired && (element.Hired >= CurrentDateThree && element.Hired <= CurrentDateOne)) {
                                this.Phase1ProjectedHires = this.Phase1ProjectedHires  + 1;
                            }
                            this.dateDifferenceJanToCurrentYear(CurrentDateOne, CurrentDateThree);
                        }

                        this.RecruitingPerformanceMetrics(element);

                        // INTERVIEWED
                        if(element.Interviewed && (element.Interviewed >= this.startDate && element.Interviewed <= this.endDate)) {
                            this.InterviewCSVList.push(element);
                            this.Phase2InterviewsCount = this.Phase2InterviewsCount + 1;
                            
                            // THIRDPOOL AD
                            if(element.Source && element.Source == "ThirdPool Ad") {
                                this.InterviewedTileThirdPoolProspectsCount  = this.InterviewedTileThirdPoolProspectsCount + 1;
                            }
                            // NOT THIRDPOOL AD
                            if(!element.hasOwnProperty('Source') || element.Source != "ThirdPool Ad") {
                                this.InterviewedTileOrganicProspectsCount = this.InterviewedTileOrganicProspectsCount + 1;
                            }

                            if(element.InterviewScore) {
                                this.SumInterviewScore = this.SumInterviewScore + element.InterviewScore;
                                this.CountInterviewScore = this.CountInterviewScore + 1;
                            }

                        }

                        // INTERVIEWED NO SHOW
                        if(element.hasOwnProperty('InterviewShow') && (element.InterviewShow >= this.startDate && element.InterviewShow <= this.endDate)) {
                            this.Phase2InterviewNoShowCount = this.Phase2InterviewNoShowCount + 1;
                            // THIRDPOOL AD
                            if(element.Source && element.Source == "ThirdPool Ad") {
                                this.InterviewNoShowTileThirdPoolProspectsCount  = this.InterviewNoShowTileThirdPoolProspectsCount + 1;
                            }
                            // NOT THIRDPOOL AD
                            if(!element.hasOwnProperty('Source') || element.Source != "ThirdPool Ad") {
                                this.InterviewNoShowTileOrganicProspectsCount = this.InterviewNoShowTileOrganicProspectsCount + 1;
                            }
                        }

                        // HIRED
                        if(element.Hired && (element.Hired >= this.startDate && element.Hired <= this.endDate)) {
                            this.HiresCSVList.push(element);
                            this.Phase2HiredCount = this.Phase2HiredCount + 1;
                            // THIRDPOOL AD
                            if(element.Source && element.Source == "ThirdPool Ad") {
                                this.HiredTileThirdPoolProspectsCount  = this.HiredTileThirdPoolProspectsCount + 1;
                            }
                            // NOT THIRDPOOL AD
                            if(!element.hasOwnProperty('Source') || element.Source != "ThirdPool Ad") {
                                this.HiredTileOrganicProspectsCount = this.HiredTileOrganicProspectsCount + 1;
                            }
                        }

                        // LOST TO COMPETITOR 
                        if(element.LTC && (element.LTC >= this.startDate && element.LTC <= this.endDate)) {
                            this.LosttoCompetitorCSVList.push(element);
                            this.Phase2LosttoCompetitorCount = this.Phase2LosttoCompetitorCount + 1;
                            // THIRDPOOL AD
                            if(element.Source && element.Source == "ThirdPool Ad") {
                                this.LostToCompetitorTileThirdPoolProspectsCount  = this.LostToCompetitorTileThirdPoolProspectsCount + 1;
                            }
                            // NOT THIRDPOOL AD
                            if(!element.hasOwnProperty('Source') || element.Source != "ThirdPool Ad") {
                                this.LostToCompetitorTileOrganicProspectsCount = this.LostToCompetitorTileOrganicProspectsCount + 1;
                            }
                        }

                        this.ScreeningMetrics(element);
                        this.isShowConvoAnalytics = true;
                    });

                    this.ScreeningMetricManager();

                    // CCI CHART VALUE
                    var CCIYesValue = this.CCICount;
                    var CCINoValue = this.SourceCount - CCIYesValue;
                    this.cciSeries = [CCIYesValue,CCINoValue];

                    // CALCULATE AVERAGE PROSPECT QUALITY RATING 
                    this.Phase3Average = this.Phase3AverageProspectQualityRatingOneCount + this.Phase3AverageProspectQualityRatingTwoCount + this.Phase3AverageProspectQualityRatingThreeCount + this.Phase3AverageProspectQualityRatingFourCount;
                    /*if(this.Phase3Average != 0) {
                        this.Phase3FinalAverage = (this.Phase3Average / this.countSentToManager).toFixed(2);
                    }*/

                    // CALCULATE AVERAGE INTERVIEW RATING
                    let AverageInterviewRating = this.SumInterviewScore / this.CountInterviewScore;
                    if(AverageInterviewRating) {
                        this.Phase3FinalAverage = AverageInterviewRating.toFixed(2);
                    }

                    this.isShowMap = true;
                    // setTimeout(() => {
                        this.showProspectsData = true;                        
                    // }, 100);
                } else {
                    this.showProspectsData = true;
                }

                this.GoogleMapLoad();
                
                //eslint-disable-next-line
                //console.log('prospects:', this.getReportProspectData);
            },
            // PROJECTED HIRES > FIND THE DATE DIFF VALUE
            dateDifferenceJanToCurrentYear(date2, date1) {
                const _MS_PER_DAY = 1000 * 60 * 60 * 24;
                const utc1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
                const utc2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());
                var ProjectedHiresDayCount = Math.floor((utc2 - utc1) / _MS_PER_DAY); // DAY COUNT (FROM START TO END)
                var ProjectedHiresValue = this.Phase1ProjectedHires / ProjectedHiresDayCount * 365;
                this.FinalValueProjectedHires = Math.round(ProjectedHiresValue) ? Math.round(ProjectedHiresValue) : 0; //ProjectedHiresValue.toFixed(2);
            },
            // CALCULATE INBOUND OUTBOUND VALUE
            async CalculateInboundOutbound(elementconvosid) {
                if (this.convos.length) {
                    let mesRef = await db.collection(`Conversations/${elementconvosid}/Messages`).get();
                        let messageList = mesRef.docs.map((doc) => {
                        let data = {...doc.data() };
                        return data;
                    })
                    if (messageList.length) {
                        for (let m of messageList) {
                            if (m.Inbound) {
                                if(this.CheckUniqueInboundMessage == 0){
                                    this.totalInboundMessageCount = this.totalInboundMessageCount + 1;
                                    this.CheckUniqueInboundMessage = 1;
                                }
                            }else {
                                if(this.CheckUniqueOutBoundMessage == 0){
                                    this.totalOutBoundMessageCount = this.totalOutBoundMessageCount + 1;
                                    this.CheckUniqueOutBoundMessage = 1;
                                }
                            }
                        }
                        this.CheckUniqueInboundMessage = 0;
                        this.CheckUniqueOutBoundMessage = 0;
                    }
                    if (this.totalInboundMessageCount && this.totalOutBoundMessageCount) {
                        this.InitialResponseRateCount = ((this.totalInboundMessageCount / this.totalOutBoundMessageCount)*100).toFixed(2);
                        this.InitialResponseRateCount = Math.round(this.InitialResponseRateCount);
                    }
                    this.isShowConvoAnalytics = true;
                } else {
                    this.isShowConvoAnalytics = true;
                }
            },
            getFileName() {
                return  this.user.Company+'-'+this.$parsePlainDate(new Date(this.form.date_s).getTime())+'-'+this.$parsePlainDate(new Date(this.form.date_e).getTime())+'-prospects.csv';
            },
            // CSV EXPORT > SENT PROSPECT MANAGER
            SentProspectCSVData() {
                let csvDataJson = this.prospectMangerCSVList;
                if(this.SentProspectManagerCSVDownloadCount == 0) {
                    this.SentProspectManagerCSVDownloadCount = this.SentProspectManagerCSVDownloadCount+1;
                    csvDataJson.sort((a, b) => b.SentOn - a.SentOn);
                    csvDataJson.forEach(element => {
                        let so = this.$parsePlainDate(element.SentOn);
                        element['DuplicateSentOn9'] = so;
                        element['DuplicateFirst9'] = element.First;
                        element['DuplicateLast9'] = element.Last;
                        element['DuplicateEmail9'] = element.Email;
                        element['DuplicateNumber9'] = element.Number;
                        element['DuplicateZip9'] = element.Zip;
                        element['DuplicateSource9'] = element.Source;
                        element['DuplicateNotes9'] = element.Notes;
                        element['DuplicateOffice9'] = element.Office;
                        element['DuplicateMName9'] = element.MName;
                        element['DuplicateMEmail9'] = element.MEmail;
                        element['DuplicateMNumber9'] = element.MNumber;
                        let ro = this.$parsePlainDate(element.ReviewedOn);
                        element['DuplicateReviewedOn9'] = ro;
                        element['DuplicateRating9'] = element.Rating;
                        element['DuplicateMNote9'] = element.MNote;
                    })
                }
                return csvDataJson;
            },
            getCSVData() {
                let csvDataJson = this.dateRangeProspect;
                // let csvDataJson = this.dateRangeProspect.sort((a, b) => b.DateCreated - a.DateCreated);
                if (this.downloadCount == 0) {
                    this.downloadCount = this.downloadCount+1;
                    csvDataJson.sort((a, b) => b.DateCreated - a.DateCreated);
                    csvDataJson.forEach(element => {
                        let dc = this.$parsePlainDate(element.DateCreated) + '-' + this.$parsePlainTime(element.DateCreated);
                        // element.DateCreated = dc;
                        element['DateCreatedDuplicte'] = dc;
                        element['DuplicateOfficePrimary'] ='';
                        if(element.Office != null && typeof element.Office !== 'undefined'){
                            let OfficeNameGet = this.user.Offices.find(uo1 => uo1.OfficeId == element.Office);
                             if(OfficeNameGet != null && typeof OfficeNameGet !== 'undefined') {
                                element['DuplicateOfficePrimary'] = OfficeNameGet.OfficeName;
                            }
                        }
                        
                        /*if (element.Starred == true) {
                            element.Starred = 'Yes'
                        }else if (element.Starred == false){
                            element.Starred = 'No'
                        }*/
                        if (element.Starred == true) {
							element['DuplicateStarred'] = 'Yes'
						}else if (element.Starred == false){
							element['DuplicateStarred'] = 'No'
						}
                        if (element.Notes && element.Notes.length) {
							const newObj = element.Notes.map(key1 => {
								let key11 = this.$parsePlainDate(key1['date']);
								let value = key1['description'];
								return { [key11]:value }
							});
							element['DuplicateNotes'] = JSON.stringify(newObj);                            
						}
                        element['DuplicateInterviewed']='';
                        if(element.Interviewed && element.Interviewed != 0 && element.Interviewed != ""){
                            element['DuplicateInterviewed']=this.$parsePlainDate(element.Interviewed);
                        }
                        element['DuplicateHired']='';
                        if(element.Hired && element.Hired != 0){
                            element['DuplicateHired']=this.$parsePlainDate(element.Hired); 
                        }
                       
                        /*if (Object.keys(element.Notes).length) {
                            const newObj = Object.keys(element.Notes).map(key => {
                                let key11 = this.$parsePlainDate(key)
                                let value = element.Notes[key];
                                return { [key11]:value }
                            });
                            element['DuplicateNotes'] = JSON.stringify(newObj);                            
                        }*/
                    });
                }
                return csvDataJson;
            },

            // GENERATE CSV FILE NAME
            getRPMFileName(FileNameGet) {
                return  this.user.Company+'-'+this.$parsePlainDate(new Date(this.form.date_s).getTime())+'-'+this.$parsePlainDate(new Date(this.form.date_e).getTime())+'-'+FileNameGet+'.csv';
            },
            
            // CSV EXPORT > ORGANIC  
            OrganicCSVData() {
                const a = Object.assign(this.NotThirdPoolProspectsCSVList);
                if (this.OrganicCSVDownloadCount == 0) {
                   this.OrganicCSVDownloadCount = this.OrganicCSVDownloadCount+1;
                    a.sort((a, b) => b.DateCreated - a.DateCreated);
                    a.forEach(uo => {
                        let dc = this.$parsePlainDate(uo.DateCreated) + '-' + this.$parsePlainTime(uo.DateCreated);
                        uo['DateCreatedDuplicte1'] = dc;
                        uo['DuplicateFirst1'] = uo.First;
                        uo['DuplicateLast1'] = uo.Last;
                         if (uo.Notes && uo.Notes.length) {
							const newObj = uo.Notes.map(key1 => {
								let key11 = this.$parsePlainDate(key1['date']);
								let value = key1['description'];
								return { [key11]:value }
							});
							uo['DuplicateNotes1'] = JSON.stringify(newObj);                            
						}
                        if(uo.Office != null && typeof uo.Office !== 'undefined') {
                            let OfficeNameGet = this.user.Offices.find(uo1 => uo1.OfficeId == uo.Office);
                            if(OfficeNameGet != null && typeof OfficeNameGet !== 'undefined') {
                                uo['DuplicateOffice1'] = OfficeNameGet.OfficeName;
                                let ManagerNameGet = this.user.Managers.find(um => um.MgrID == OfficeNameGet.MgrID);
                                if(ManagerNameGet && ManagerNameGet != null && typeof ManagerNameGet !== 'undefined') {
                                    uo['DuplicateManager1'] = ManagerNameGet.First+' '+ManagerNameGet.Last;
                                } else {
                                    uo['DuplicateManager1'] = '';
                                }
                            } else {
                                uo['DuplicateOffice1'] = '';
                                uo['DuplicateManager1'] = '';
                            }
                        } else {
                            uo['DuplicateOffice1'] = '';
                            uo['DuplicateManager1'] = '';
                        }
                        uo['DuplicateEvent1'] = 'Organic Prospects';
                    }); 
                }
                return a;
            },
            // CSV EXPORT > INTERVIEW 
            InterviewCSVData() {
                const b = Object.assign(this.InterviewCSVList);
                if (this.InterviewCSVDownloadCount == 0) {
                    this.InterviewCSVDownloadCount = this.InterviewCSVDownloadCount+1;
                    b.sort((a, b) => b.DateCreated - a.DateCreated);
                    b.forEach(uo => {
                        let dc = this.$parsePlainDate(uo.DateCreated) + '-' + this.$parsePlainTime(uo.DateCreated);
                        uo['DateCreatedDuplicte2'] = dc;
                        uo['DuplicateFirst2'] = uo.First;
                        uo['DuplicateLast2'] = uo.Last;
                        if (uo.Notes && uo.Notes.length) {
							const newObj = uo.Notes.map(key1 => {
								let key11 = this.$parsePlainDate(key1['date']);
								let value = key1['description'];
								return { [key11]:value }
							});
							uo['DuplicateNotes2'] = JSON.stringify(newObj);                            
						}
                        if(uo.Office != null && typeof uo.Office !== 'undefined') {
                            let OfficeNameGet = this.user.Offices.find(uo1 => uo1.OfficeId == uo.Office);
                            if(OfficeNameGet != null && typeof OfficeNameGet !== 'undefined') {
                                uo['DuplicateOffice2'] = OfficeNameGet.OfficeName;
                                let ManagerNameGet = this.user.Managers.find(um => um.MgrID == OfficeNameGet.MgrID);
                                if(ManagerNameGet && ManagerNameGet != null && typeof ManagerNameGet !== 'undefined') {
                                    uo['DuplicateManager2'] = ManagerNameGet.First+' '+ManagerNameGet.Last;
                                } else {
                                    uo['DuplicateManager2'] = '';
                                }
                            } else {
                                uo['DuplicateOffice2'] = '';
                                uo['DuplicateManager2'] = '';
                            }
                        } else {
                            uo['DuplicateOffice2'] = '';
                            uo['DuplicateManager2'] = '';
                        }
                        uo['DuplicateEvent2'] = 'Interviews';
                        uo['DuplicateInterviewed2'] = this.$parsePlainDate(uo.Interviewed);
                    }); 
                }
                return b;
            },
            // CSV EXPORT > THIRDPOOL 
            ThirdPoolCSVData() {
                const a = Object.assign(this.ThirdPoolProspectsCSVList);
                if (this.ThirdPoolCSVDownloadCount == 0) {
                   this.ThirdPoolCSVDownloadCount = this.ThirdPoolCSVDownloadCount+1;
                    a.sort((a, b) => b.DateCreated - a.DateCreated);
                    a.forEach(uo => {
                        let dc = this.$parsePlainDate(uo.DateCreated) + '-' + this.$parsePlainTime(uo.DateCreated);
                        uo['DateCreatedDuplicte3'] = dc;
                        uo['DuplicateFirst3'] = uo.First;
                        uo['DuplicateLast3'] = uo.Last;

                        if (uo.Notes && uo.Notes.length) {
							const newObj = uo.Notes.map(key1 => {
								let key11 = this.$parsePlainDate(key1['date']);
								let value = key1['description'];
								return { [key11]:value }
							});
							uo['DuplicateNotes3'] = JSON.stringify(newObj);                            
						}

                        if(uo.Office != null && typeof uo.Office !== 'undefined') {
                            let OfficeNameGet = this.user.Offices.find(uo1 => uo1.OfficeId == uo.Office);
                            if(OfficeNameGet != null && typeof OfficeNameGet !== 'undefined') {
                                uo['DuplicateOffice3'] = OfficeNameGet.OfficeName;
                                let ManagerNameGet = this.user.Managers.find(um => um.MgrID == OfficeNameGet.MgrID);
                                if(ManagerNameGet && ManagerNameGet != null && typeof ManagerNameGet !== 'undefined') {
                                    uo['DuplicateManager3'] = ManagerNameGet.First+' '+ManagerNameGet.Last;
                                } else {
                                    uo['DuplicateManager3'] = '';
                                }
                            } else {
                                uo['DuplicateOffice3'] = '';
                                uo['DuplicateManager3'] = '';
                            }
                        } else {
                            uo['DuplicateOffice3'] = '';
                            uo['DuplicateManager3'] = '';
                        }
                        uo['DuplicateEvent3'] = 'ThirdPool Prospects';
                    }); 
                }
                return a;
            },
            // CSV EXPORT > HIRES 
            HireCSVData() {
                const a = Object.assign(this.HiresCSVList);
                if (this.HireCSVDownloadCount == 0) {
                   this.HireCSVDownloadCount = this.HireCSVDownloadCount+1;
                    a.sort((a, b) => b.DateCreated - a.DateCreated);
                    a.forEach(uo => {
                        let dc = this.$parsePlainDate(uo.DateCreated) + '-' + this.$parsePlainTime(uo.DateCreated);
                        uo['DateCreatedDuplicte4'] = dc;
                        uo['DuplicateFirst4'] = uo.First;
                        uo['DuplicateLast4'] = uo.Last;
                        if (uo.Notes && uo.Notes.length) {
							const newObj = uo.Notes.map(key1 => {
								let key11 = this.$parsePlainDate(key1['date']);
								let value = key1['description'];
								return { [key11]:value }
							});
							uo['DuplicateNotes4'] = JSON.stringify(newObj);                            
						}
                        if(uo.Office != null && typeof uo.Office !== 'undefined') {
                            let OfficeNameGet = this.user.Offices.find(uo1 => uo1.OfficeId == uo.Office);
                            if(OfficeNameGet != null && typeof OfficeNameGet !== 'undefined') {
                                uo['DuplicateOffice4'] = OfficeNameGet.OfficeName;
                                let ManagerNameGet = this.user.Managers.find(um => um.MgrID == OfficeNameGet.MgrID);
                                if(ManagerNameGet && ManagerNameGet != null && typeof ManagerNameGet !== 'undefined') {
                                    uo['DuplicateManager4'] = ManagerNameGet.First+' '+ManagerNameGet.Last;
                                } else {
                                    uo['DuplicateManager4'] = '';
                                }
                            } else {
                                uo['DuplicateOffice4'] = '';
                                uo['DuplicateManager4'] = '';
                            }
                        } else {
                            uo['DuplicateOffice4'] = '';
                            uo['DuplicateManager4'] = '';
                        }
                        uo['DuplicateEvent4'] = 'Hires';
                        uo['DuplicateHire4'] = this.$parsePlainDate(uo.Hired);
                    }); 
                }
                return a;
            },
            // CSV EXPORT > PRE INTERVIEW 
            PreInterviewCSVData() {
                const a = Object.assign(this.PreInterviewNurtureCSVList);
                if (this.PreInterviewCSVDownloadCount == 0) {
                   this.PreInterviewCSVDownloadCount = this.PreInterviewCSVDownloadCount+1;
                    a.sort((a, b) => b.DateCreated - a.DateCreated);
                    a.forEach(uo => {
                        let dc = this.$parsePlainDate(uo.DateCreated) + '-' + this.$parsePlainTime(uo.DateCreated);
                        uo['DateCreatedDuplicte5'] = dc;
                        uo['DuplicateFirst5'] = uo.First;
                        uo['DuplicateLast5'] = uo.Last;
                        if (uo.Notes && uo.Notes.length) {
                            const newObj = uo.Notes.map(key1 => {
                                let key11 = this.$parsePlainDate(key1['date']);
                                let value = key1['description'];
                                return { [key11]:value }
                            });
                            uo['DuplicateNotes5'] = JSON.stringify(newObj);                            
                        }
                        if(uo.Office != null && typeof uo.Office !== 'undefined') {
                            let OfficeNameGet = this.user.Offices.find(uo1 => uo1.OfficeId == uo.Office);
                            if(OfficeNameGet != null && typeof OfficeNameGet !== 'undefined') {
                                uo['DuplicateOffice5'] = OfficeNameGet.OfficeName;
                                let ManagerNameGet = this.user.Managers.find(um => um.MgrID == OfficeNameGet.MgrID);
                                if(ManagerNameGet && ManagerNameGet != null && typeof ManagerNameGet !== 'undefined') {
                                    uo['DuplicateManager5'] = ManagerNameGet.First+' '+ManagerNameGet.Last;
                                } else {
                                    uo['DuplicateManager5'] = '';
                                }
                            } else {
                                uo['DuplicateOffice5'] = '';
                                uo['DuplicateManager5'] = '';
                            }
                        } else {
                            uo['DuplicateOffice5'] = '';
                            uo['DuplicateManager5'] = '';
                        }
                        uo['DuplicateEvent5'] = 'Pre-Interview Nurture';
                    }); 
                }
                return a;
            },
            // CSV EXPORT > POST INTERVIEW
            PostInterviewCSVData() {
                const a = Object.assign(this.PostInterviewNurtureCSVList);
                if (this.PostInterviewCSVDownloadCount == 0) {
                   this.PostInterviewCSVDownloadCount = this.PostInterviewCSVDownloadCount+1;
                    a.sort((a, b) => b.DateCreated - a.DateCreated);
                    a.forEach(uo => {
                        let dc = this.$parsePlainDate(uo.DateCreated) + '-' + this.$parsePlainTime(uo.DateCreated);
                        uo['DateCreatedDuplicte6'] = dc;
                        uo['DuplicateFirst6'] = uo.First;
                        uo['DuplicateLast6'] = uo.Last;
                        if (uo.Notes && uo.Notes.length) {
                            const newObj = uo.Notes.map(key1 => {
                                let key11 = this.$parsePlainDate(key1['date']);
                                let value = key1['description'];
                                return { [key11]:value }
                            });
                            uo['DuplicateNotes6'] = JSON.stringify(newObj);                            
                        }
                        if(uo.Office != null && typeof uo.Office !== 'undefined') {
                            let OfficeNameGet = this.user.Offices.find(uo1 => uo1.OfficeId == uo.Office);
                            if(OfficeNameGet != null && typeof OfficeNameGet !== 'undefined') {
                                uo['DuplicateOffice6'] = OfficeNameGet.OfficeName;
                                let ManagerNameGet = this.user.Managers.find(um => um.MgrID == OfficeNameGet.MgrID);
                                if(ManagerNameGet && ManagerNameGet != null && typeof ManagerNameGet !== 'undefined') {
                                    uo['DuplicateManager6'] = ManagerNameGet.First+' '+ManagerNameGet.Last;
                                } else {
                                    uo['DuplicateManager6'] = '';
                                }
                            } else {
                                uo['DuplicateOffice6'] = '';
                                uo['DuplicateManager6'] = '';
                            }
                        } else {
                            uo['DuplicateOffice6'] = '';
                            uo['DuplicateManager6'] = '';
                        }
                        uo['DuplicateEvent6'] = 'Post-Interview Nurture';
                    }); 
                }
                return a;
            },
            // CSV EXPORT > OFFER 
            OfferCSVData() {
                const a = Object.assign(this.OffersCSVList);
                if (this.OfferCSVDownloadCount == 0) {
                   this.OfferCSVDownloadCount = this.OfferCSVDownloadCount+1;
                    a.sort((a, b) => b.DateCreated - a.DateCreated);
                    a.forEach(uo => {
                        let dc = this.$parsePlainDate(uo.DateCreated) + '-' + this.$parsePlainTime(uo.DateCreated);
                        uo['DateCreatedDuplicte7'] = dc;
                        uo['DuplicateFirst7'] = uo.First;
                        uo['DuplicateLast7'] = uo.Last;
                        if (uo.Notes && uo.Notes.length) {
                            const newObj = uo.Notes.map(key1 => {
                                let key11 = this.$parsePlainDate(key1['date']);
                                let value = key1['description'];
                                return { [key11]:value }
                            });
                            uo['DuplicateNotes7'] = JSON.stringify(newObj);                            
                        }
                        if(uo.Office != null && typeof uo.Office !== 'undefined') {
                            let OfficeNameGet = this.user.Offices.find(uo1 => uo1.OfficeId == uo.Office);
                            if(OfficeNameGet != null && typeof OfficeNameGet !== 'undefined') {
                                uo['DuplicateOffice7'] = OfficeNameGet.OfficeName;
                                let ManagerNameGet = this.user.Managers.find(um => um.MgrID == OfficeNameGet.MgrID);
                                if(ManagerNameGet && ManagerNameGet != null && typeof ManagerNameGet !== 'undefined') {
                                    uo['DuplicateManager7'] = ManagerNameGet.First+' '+ManagerNameGet.Last;
                                } else {
                                    uo['DuplicateManager7'] = '';
                                }
                            } else {
                                uo['DuplicateOffice7'] = '';
                                uo['DuplicateManager7'] = '';
                            }
                        } else {
                            uo['DuplicateOffice7'] = '';
                            uo['DuplicateManager7'] = '';
                        }
                        uo['DuplicateEvent7'] = 'Offers';
                    }); 
                }
                return a;
            },
            // CSV EXPORT > LOST TO COMPETITORS 
            LosttoCompCSVData() {
                const a = Object.assign(this.LosttoCompetitorCSVList);
                if (this.LostToCompCSVDownloadCount == 0) {
                   this.LostToCompCSVDownloadCount = this.LostToCompCSVDownloadCount+1;
                    a.sort((a, b) => b.DateCreated - a.DateCreated);
                    a.forEach(uo => {
                        let dc = this.$parsePlainDate(uo.DateCreated) + '-' + this.$parsePlainTime(uo.DateCreated);
                        uo['DateCreatedDuplicte8'] = dc;
                        uo['DuplicateFirst8'] = uo.First;
                        uo['DuplicateLast8'] = uo.Last;
                         if (uo.Notes && uo.Notes.length) {
                            const newObj = uo.Notes.map(key1 => {
                                let key11 = this.$parsePlainDate(key1['date']);
                                let value = key1['description'];
                                return { [key11]:value }
                            });
                            uo['DuplicateNotes8'] = JSON.stringify(newObj);                            
                        }
                        if(uo.Office != null && typeof uo.Office !== 'undefined') {
                            let OfficeNameGet = this.user.Offices.find(uo1 => uo1.OfficeId == uo.Office);
                            if(OfficeNameGet != null && typeof OfficeNameGet !== 'undefined') {
                                uo['DuplicateOffice8'] = OfficeNameGet.OfficeName;
                                let ManagerNameGet = this.user.Managers.find(um => um.MgrID == OfficeNameGet.MgrID);
                                if(ManagerNameGet && ManagerNameGet != null && typeof ManagerNameGet !== 'undefined') {
                                    uo['DuplicateManager8'] = ManagerNameGet.First+' '+ManagerNameGet.Last;
                                } else {
                                    uo['DuplicateManager8'] = '';
                                }
                            } else {
                                uo['DuplicateOffice8'] = '';
                                uo['DuplicateManager8'] = '';
                            }
                        } else {
                            uo['DuplicateOffice8'] = '';
                            uo['DuplicateManager8'] = '';
                        }
                        uo['DuplicateEvent8'] = 'Lost to Competitors';
                    }); 
                }
                return a;
            },

            // ON CHANGE OFFICE EVENT FIRE
            checkFilterByOfficeValue1(event) {
                if(event.target.checked == true) {
                    this.array1.push(event.target.value);
                    this.FilterByCount = this.FilterByCount + 1; 
                } else {
                    this.array1.splice(this.array1.indexOf(event.target.value), 1);
                    this.FilterByCount = this.FilterByCount - 1;
                }
                this.array1 = this.array1.map((i) => Number(i)) // ['313', '176'] to [313,176]
            },
            // ON CHANGE MANAGER EVENT FIRE
            checkFilterByManagerValue1(event) {
                if(event.target.checked == true) {
                    this.array2.push(event.target.value);
                    this.FilterByCount = this.FilterByCount + 1; 
                } else {
                    this.array2.splice(this.array2.indexOf(event.target.value), 1);
                    this.FilterByCount = this.FilterByCount - 1; 
                } 
            },
            // ON CHANGE SOURCE EVENT FIRE
            checkFilterBySourceValue1(event) {
                this.Tone = [];
                if(event.target.checked == true) {
                    this.array4.push(event.target.value);
                    this.FilterByCount = this.FilterByCount + 1; 
                } else {
                    this.array4.splice(this.array4.indexOf(event.target.value), 1);
                    this.FilterByCount = this.FilterByCount - 1; 
                } 
                // this.array4 = this.array4.map((i) => Number(i))
                this.arrayFourManage();
            },
            arrayFourManage() {
                this.array4.forEach(sourceID => {
                    if(this.FilterReportProspectData.length == 0) {
                        this.getReportProspectData = this.ReportProspectData;
                    } else {
                        this.getReportProspectData = this.getReportProspectData;
                    }

                    if (this.getReportProspectData) {
                        this.getReportProspectData.forEach(element => {
                            if(sourceID == 1) {
                                if(element.Source && element.Source == "ThirdPool Ad") {
                                    this.Tone.push(element);
                                }
                            }
                            if(sourceID == 2) {
                                if((!element.hasOwnProperty('Source') || element.Source != "ThirdPool Ad")) {
                                    this.Tone.push(element);
                                }
                            }
                        });
                    }

                }); 
            },
            checkFilterByOfficeValue(event) {
                if(event.target.checked == true) {
                    this.OfficesArrTrueFalse.push(event.target.value);
                    this.FilterByCount = this.FilterByCount + 1; 
                } else {
                    this.OfficesArrTrueFalse.splice(this.OfficesArrTrueFalse.indexOf(event.target.value), 1);
                    this.FilterByCount = this.FilterByCount - 1;
                }
                this.newProspects = [];
                this.OfficesArrTrueFalse.forEach(oa => {
                    let newProspectsData = this.getReportProspectData.find(ps => ps.Office == oa);
                    if(newProspectsData != null && newProspectsData !== 'undefined') {
                        this.newProspects.push(newProspectsData);
                    }
                });
           },
            checkFilterByManagerValue(event) {
                if(event.target.checked == true) {
                    this.ManagerArrTrueFalse.push(event.target.value);
                    this.FilterByCount = this.FilterByCount + 1; 
                } else {
                    this.ManagerArrTrueFalse.splice(this.ManagerArrTrueFalse.indexOf(event.target.value), 1);
                    this.FilterByCount = this.FilterByCount - 1; 
                } 
               
                this.getOfficeIDFromMgr = [];
                this.ManagerArrTrueFalse.forEach(ma => {
                    this.user.Offices.forEach(um => {
                        if(um.MgrID == ma) {
                            let OfficeIDFromMgrData = this.getReportProspectData.find(ps => ps.Office == um.OfficeId); 
                            if(OfficeIDFromMgrData != null && OfficeIDFromMgrData !== 'undefined') {
                                this.getOfficeIDFromMgr.push(OfficeIDFromMgrData);
                            }
                        }
                    });
                });
                //eslint-disable-next-line
                //console.log('this.getOfficeIDFromMgr:', this.getOfficeIDFromMgr);
            },

            // FILTER > GET OFFICE DATA
            OfficeNameWithName()
            {
                let OfficeData = [];
                Object.assign(OfficeData,this.user.Offices)
                OfficeData.forEach(uo => {
                    uo['name'] = uo.OfficeName;
                });
                return OfficeData;
            },
            // FILTER > GET MANAGER DATA
            ManagerNameWithName()
            {
                let ManagerData = [];
                Object.assign(ManagerData,this.user.Managers)
                ManagerData.forEach(um => {
                    um['name'] = um.First+' '+um.Last;
                });
                return ManagerData;
            },
            // FILTER > GET SOURCE DATA
            SourceNameWithName()
            {
                let SourceData = [
                    { name: 'ThirdPool Ad', id: 1 },
                    { name: 'Organic', id: 2 }
                ];
                return SourceData;
            },
            
            // FILTER > BIND OFFICE, MANAGER DATA
            FilterByOfficesManagers()
            {
                this.OfficeDataCheckbox.push({
                    name:'Offices',
                    list:this.OfficeNameWithName()
                },{
                    name:'Managers',
                    list:this.ManagerNameWithName()
                },{
                    name:'Source',
                    list: this.SourceNameWithName(),
                })
            },

            // INIT RESET VALUES
            initResetValues()
            {
                // this.array1=[],
                // this.array2=[],
                this.array3=[],
                // this.array4=[],
                // this.array5=[],
                this.mapnameglobal = [],
                
                this.CheckUniqueInboundMessage='';
                this.CheckUniqueOutBoundMessage='';
                this.prospMapDetailArray=[];
                this.FilterByGetData=[];
                this.FilterReportProspectData=[];

                this.prospectMangerCSVList = [];

                this.ThirdPoolProspectsCSVList=[];
                // this.Tone=[];
                this.NotThirdPoolProspectsCSVList=[];
                this.PreInterviewNurtureCSVList=[];
                this.PostInterviewNurtureCSVList=[];
                this.InterviewCSVList=[];
                this.OffersCSVList=[];
                this.HiresCSVList=[];
                this.LosttoCompetitorCSVList=[];

                this.countSentToManager = 0;
                this.Phase1newCount = 0;
                this.Phase1ContactedCount = 0;
                this.Phase1PreInterviewNurtureCount = 0;
                this.Phase1PostInterviewNurtureCount = 0;
                this.Phase1OfferCount = 0;

                this.Phase2ThirdPoolProspectsCount = 0;
                this.Phase2OrganicProspectsCount = 0;
                this.Phase2PreInterviewNurtureCount = 0;
                this.Phase2InterviewsCount = 0;
                this.Phase2InterviewNoShowCount = 0;
                this.Phase2PostInterviewNurtureCount = 0;
                this.Phase2OfferCount = 0;
                this.Phase2HiredCount = 0;
                this.Phase2LosttoCompetitorCount = 0;
                this.CCICount = 0;
                this.CountInterviewScore = 0;
                this.SumInterviewScore = 0;

                this.Phase3ProspectsSenttoManagersCount = 0;
                this.Phase3ProspectsReviewedbyManagersCount = 0;
                this.Phase3AverageProspectQualityRatingOneCount = 0;
                this.Phase3AverageProspectQualityRatingTwoCount = 0;
                this.Phase3AverageProspectQualityRatingThreeCount = 0;
                this.Phase3AverageProspectQualityRatingFourCount = 0;
                this.Phase3Average = 0;

                this.Phase4OutboundStep1 = 0;
                this.Phase4OutboundStep2 = 0;
                
                this.totalInboundMessageCount = 0;
                this.totalOutBoundMessageCount = 0;
                this.totalResonseRateCount = 0;

                this.InitialResponseRateCount = 0;
                this.Phase3FinalAverage = 0;
                this.Phase1ProjectedHires = 0;
                this.FinalValueProjectedHires = 0;
                this.SourceCount = 0;

                this.totalSentProspect = 0;
                this.totalReviewdProspect = 0;

                this.InterviewedTileThirdPoolProspectsCount = 0;
                this.InterviewedTileOrganicProspectsCount = 0;
                this.InterviewNoShowTileThirdPoolProspectsCount = 0;
                this.InterviewNoShowTileOrganicProspectsCount = 0;
                this.HiredTileThirdPoolProspectsCount = 0;
                this.HiredTileOrganicProspectsCount = 0;
                this.LostToCompetitorTileThirdPoolProspectsCount = 0;
                this.LostToCompetitorTileOrganicProspectsCount = 0;
            },
            // PIE CHART COLOR OPTIONS
            chartColors()
            {
                let colorShades = ['#008ffb','#00e396','#feb019','#ff4560','#775dd0','#408C84', '#FBA720', '#71D9B9', '#44CB5F', '#B7FD12', '#A64903', '#080AE6', '#E26B1E', '#504C88', '#B626C1', '#E1582D', '#DF7C49', '#B17AD1', '#9FD7C4', '#40EF79', '#5AF2A1', '#5B3651', '#38FB45', '#504C1E', '#B78FB8', '#B4CCE4', '#C8686A', '#B37585', '#CEA6AB', '#01162E', '#638AAF', '#8C78BC', '#815217', '#E0A06B', '#99D8B6', '#94BC64', '#5A57D3', '#A5C18B', '#CE00B1', '#3E8532', '#D083B4', '#59F39C', '#23C17F', '#AD424E', '#F53CA2', '#FF1862', '#2F9BB7', '#993894', '#DFDAB5', '#70B3ED', '#452A2D', '#5CA94D', '#0C850A', '#650F70', '#DDC9D4', '#C6C38B', '#855D3C', '#C353E7', '#952C74', '#1E28CC'];
                return colorShades;
            },
            // RECRUITING PIPELINE
            RecruitingPipeline()
            {
                let NewStageDataCount = this.getReportProspectData.filter(rp => rp.Status == "New");
                this.Phase1newCount = NewStageDataCount.length;

                let ContactedStageDataCount = this.getReportProspectData.filter(rp => rp.Status == "Contacted");
                this.Phase1ContactedCount = ContactedStageDataCount.length;

                let PreInterviewStageDataCount = this.getReportProspectData.filter(rp => rp.Status == "Pre-Interview Nurture");
                this.Phase1PreInterviewNurtureCount = PreInterviewStageDataCount.length;

                let PostInterviewStageDataCount = this.getReportProspectData.filter(rp => rp.Status == "Post-Interview Nurture");
                this.Phase1PostInterviewNurtureCount = PostInterviewStageDataCount.length;

                let OfferStageDataCount = this.getReportProspectData.filter(rp => rp.Status == "Offer");
                this.Phase1OfferCount = OfferStageDataCount.length;
            },

            

            ScreeningMetricManager() {
                const managerList = [];
				if (this.user.Managers) {
                    // managerList = this.user.Managers;
                    this.user.Managers.forEach(val => managerList.push(Object.assign({}, val)));
                }
                managerList.forEach(element => {
                    let managerProps = [];
                    let reviewdCount = 0;
                    for(let pro of this.getReportProspectData) {
                        if (pro.hasOwnProperty('SentToManager')) {
                            let sentManager = pro.SentToManager;
                            let sm = sentManager.find(sm => sm.Manager == element.MgrID);
                            if (sm) {
                                if (this.form.s_date && this.form.e_date) {
                                   
                                    if ((sm.SentOn >= this.startDate && sm.SentOn <= this.endDate)) {
                                        managerProps.push({
                                            SentOn:sm.SentOn,
                                            First:pro.First,
                                            Last:pro.Last,
                                            Email:pro.Email,
                                            Number:pro.Number,
                                            Zip:pro.Zip,
                                            rating:sm.Rating,
                                            id:pro.id,
                                            Source:pro.Source,
                                            Notes:sm.Notes,
                                            Office:element.Office,
                                            MName:element.First +' '+element.Last,
                                            MEmail:element.Email,
                                            MNumber:element.Number,
                                            ReviewedOn:sm.ReviewedOn,
                                            Rating:sm.Rating,
                                            MNote:sm.MgrNotes
                                        });
                                        if (sm.ReviewedOn && sm.Rating) {
                                            reviewdCount++;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    element.managerProps = managerProps;
                    element.ProspectsSent = managerProps.length;
                    element.ProspectsReviewed = reviewdCount;
                    this.calculateProspectCount(element.ProspectsSent,reviewdCount,managerProps);
                });
				// return managerList;
			},

            calculateProspectCount(scount,rcount,manProsp) {
                if (scount) {
                    this.prospectMangerCSVList = this.prospectMangerCSVList.concat(manProsp)
                }
                this.totalSentProspect = this.totalSentProspect + scount;
                this.totalReviewdProspect = this.totalReviewdProspect + rcount;
                
                //eslint-disable-next-line
                //console.log('totalSentProspect:', this.totalSentProspect);
                //eslint-disable-next-line
                // console.log('totalReviewdProspect:', this.totalReviewdProspect);
            },
            
            // Screening Metrics
            ScreeningMetrics(element)
            {   
                if(typeof element.SentToManager !== 'undefined') {
                    //eslint-disable-next-line
                    // console.log('element:', element);
                    element.SentToManager.filter(element1 => {
                        // if(element1.SentOn && (element1.SentOn >= FilterSDate && element1.SentOn <= this.endDate)) { 
                        //     this.Phase3ProspectsSenttoManagersCount = this.Phase3ProspectsSenttoManagersCount + 1;
                        // }

                        if(element1.ReviewedOn && (element1.ReviewedOn >= this.startDate && element1.ReviewedOn <= this.endDate)) {
                            // this.Phase3ProspectsReviewedbyManagersCount = this.Phase3ProspectsReviewedbyManagersCount + 1;
                            if(element1.ReviewedOn != '' && typeof element1.ReviewedOn !== 'undefined') {
                                if(element1.Rating == 'Excellent') {
                                    var ExcellentValue = 1;
                                    this.Phase3AverageProspectQualityRatingOneCount = this.Phase3AverageProspectQualityRatingOneCount + ExcellentValue;
                                    this.countSentToManager = this.countSentToManager + 1;
                                }
                                if(element1.Rating == 'Good') {
                                    var GoodValue = 2;
                                    this.Phase3AverageProspectQualityRatingTwoCount = this.Phase3AverageProspectQualityRatingTwoCount + GoodValue;
                                    this.countSentToManager = this.countSentToManager + 1;
                                }
                                if(element1.Rating == 'Fair') {
                                    var FairValue = 3;
                                    this.Phase3AverageProspectQualityRatingThreeCount = this.Phase3AverageProspectQualityRatingThreeCount + FairValue;
                                    this.countSentToManager = this.countSentToManager + 1;
                                }
                                if(element1.Rating == 'Poor') {
                                    var PoorValue = 4;
                                    this.Phase3AverageProspectQualityRatingFourCount = this.Phase3AverageProspectQualityRatingFourCount + PoorValue;
                                    this.countSentToManager = this.countSentToManager + 1;
                                }
                            }
                        }
                    });
                }
            },
            // Recruiting Performance Metrics
            RecruitingPerformanceMetrics(element)
            {
                if (element.Stages && element.Stages.length > 0) {
                    element.Stages.filter(element1 => {
                        if(element1.Date && (element1.Date >= this.startDate && element1.Date <= this.endDate)) { 
                            if(element1.Stage == "Pre-Interview Nurture") {
                                this.PreInterviewNurtureCSVList.push(element);
                                this.Phase2PreInterviewNurtureCount = this.Phase2PreInterviewNurtureCount + 1;
                            }
                            if(element1.Stage == "Post-Interview Nurture") {
                                this.PostInterviewNurtureCSVList.push(element);
                                this.Phase2PostInterviewNurtureCount = this.Phase2PostInterviewNurtureCount + 1;
                            }
                            if(element1.Stage == "Offer") {
                                this.OffersCSVList.push(element);
                                this.Phase2OfferCount = this.Phase2OfferCount + 1;
                            }
                            // if(element1.Stage == "Lost to Competitors") {
                            //     this.LosttoCompetitorCSVList.push(element);
                            //     this.Phase2LosttoCompetitorCount = this.Phase2LosttoCompetitorCount + 1;
                            // }
                        }
                    
                    });
                }
            },
            getMonthNames() {
                const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                return monthNames[new Date().getMonth() - 1];
            }
        },
        watch: {
			prospect: {
				immediate: true,
				handler() {
					this.mapbox = Mapbox;
					this.mapbox.accessToken  = this.accessToken;
                    this.zipCodeDetails = {}
                }
			}
		},
        data() {
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            var GetOnlyYear = date.getFullYear();
            return {

                disabledStatus: true,
                startDate:'',
                endDate:'',

                isShowH:false,
                array1:[],
                array2:[],
                array3:[],
                array4:[],
                // array5:[],

                mapnameglobal:[],

                totalSentProspect:0,
                totalReviewdProspect:0,

                array3MergeData:[],

                FilterByCount:0,

                CheckUniqueInboundMessage:0,
                CheckUniqueOutBoundMessage:0,
                FilterByGetData:[],
                FilterReportProspectData:[],
                OfficesArrTrueFalse:[],
                ManagerArrTrueFalse:[],
                getOfficeIDFromMgr:[],
                checkedOfficesID: [],
                isShowMap:false,
                map:{},
                prospMapDetailArray:[],
                accessToken: 'pk.eyJ1IjoibG9nYW5keml1ayIsImEiOiJja3BkZDJwNmcwMGgzMm5sZW5zemRhNjJlIn0.ulgQW-9KuvSNHB5IsW3IjQ',
				mapStyle:'mapbox://styles/mapbox/streets-v11',
                
                countSentToManager:0,
                Phase1newCount:0,
                Phase1ContactedCount:0,
                Phase1PreInterviewNurtureCount:0,
                Phase1PostInterviewNurtureCount:0,
                Phase1OfferCount:0,

                Phase2ThirdPoolProspectsCount:0,
                Phase2OrganicProspectsCount:0,
                Phase2PreInterviewNurtureCount:0,
                Phase2InterviewsCount:0,
                Phase2InterviewNoShowCount:0,
                Phase2PostInterviewNurtureCount:0,
                Phase2OfferCount:0,
                Phase2HiredCount:0,
                Phase2LosttoCompetitorCount:0,

                Phase3ProspectsSenttoManagersCount:0,
                Phase3ProspectsReviewedbyManagersCount:0,
                Phase3AverageProspectQualityRatingOneCount:0,
                Phase3AverageProspectQualityRatingTwoCount:0,
                Phase3AverageProspectQualityRatingThreeCount:0,
                Phase3AverageProspectQualityRatingFourCount:0,
                Phase3Average:0,

                Phase4OutboundStep1:0,
                Phase4OutboundStep2:0,
                SourceCount:0,
                CCICount:0,
                CountInterviewScore:0,
                SumInterviewScore: 0,

                totalInboundMessageCount:0,
                totalOutBoundMessageCount:0,
                totalResonseRateCount:0,
                InitialResponseRateCount:0,
                Phase3FinalAverage:0,
                Phase1ProjectedHires:0,
                FinalValueProjectedHires:0,
                NumberOfMapPros:0,

                googlelat:'',
				googlelng:'',
                
                OfficeDataCheckbox: [],
                newProspects: [],
                options11: {
                    multi: true,
                    groups: true,
                },
    
                stageChartOptions: {
                    chart: {
                        // type: 'donut',
                        // width: '100%',
                        // height: 400
                    },
                    colors: this.chartColors(),
                    dataLabels: {
                        enabled: true,
                        textAnchor: 'middle',
                    },
                    plotOptions: {
                        pie: {
                            // customScale: 0.8,
                             donut: {
                                size: '50%',
                            },
                        // offsetY: 20,
                        },
                        stroke: {
                            colors: undefined,
                        },
                        labels: {
                            show:true,
                            name:{
                                show:true,
                                color: 'red'
                            }
                        }
                    },
                    xaxis: {
                        labels: {
                            rotate: 0,
                        }
                    },
                    // colors: colorPalette,
                    title: {
                        text: 'Stage Distribution',
                        style: {
                            fontSize: '18px'
                        }
                    },
                   
                    labels: [],
                    legend: {
                        position: 'left',
                        offsetY: 30,
                        // labels:{
                        //     width:100
                        // }
                        
                    }
                },
                sourceChartOptions: {
                    chart: {
                        // type: 'donut',
                        // width: '100%',
                        // height: 400
                    },
                    colors: this.chartColors(),
                    dataLabels: {
                        enabled: true,
                        textAnchor: 'middle',
                    },
                    plotOptions: {
                        pie: {
                        // customScale: 0.8,
                        donut: {
                            size: '50%',
                        },
                        // offsetY: 20,
                        },
                        stroke: {
                            colors: undefined
                        }
                    },
                    // colors: colorPalette,
                    title: {
                        text: 'Source Distribution',
                        style: {
                            fontSize: '18px'
                        }
                    },
                   
                    labels: [],
                    legend: {
                        position: 'left',
                        offsetY: 30
                    }
                },
                CCIAssessmentChartOptions: {
                    chart: {
                        // type: 'donut',
                        // width: '100%',
                        // height: 400
                    },
                    colors: this.chartColors(),
                    dataLabels: {
                        enabled: true,
                        textAnchor: 'middle',
                    },
                    plotOptions: {
                        pie: {
                        // customScale: 0.8,
                        donut: {
                            size: '50%',
                        },
                        // offsetY: 20,
                        },
                        stroke: {
                            colors: undefined
                        }
                    },
                    // colors: colorPalette,
                    title: {
                        text: 'CCI Assessment Completion ',
                        style: {
                            fontSize: '18px'
                        }
                    },
                    labels: ['Yes', 'No'],
                    legend: {
                        position: 'left',
                        offsetY: 30
                    }
                },
                tagSeries: [{
                    name:'',
                    data: []
                }],
                tagChartOptions: {
                    chart: {
                        toolbar: {
                            show: false
                        }
                    },
                    colors: this.chartColors(),
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            horizontal: true,
                        },
                    },
                    title: {
                        text: 'Tag Distribution',
                        style: {
                            fontSize: '18px'
                        }
                    },
                    // dataLabels: {
                    //     enabled: false
                    // },
                    xaxis: {
                        categories: [],
                    },
                    legend: {
                        position: 'left',
                        offsetY: 30,
                        floating: false,
                    }
                },

                stageSeries: [],
                sourceSeries:[],
                cciSeries:[],
				isShowAnalytics:false,
                showProspectsData:false,
                items:[],
                form: {
                    date_s:firstDay,
                    date_e:new Date(),
					s_date: firstDay,
					e_date: new Date(),
				},
                totalProspect:0,
                totalCreatedTask:0,
                totalCompeletedTask:0,
                totalInboundMessage:0,
                totalOutBoundMessage:0,
                totalResonseRate:0,

                showProspectAnalytics:false,
                isShowConvoAnalytics:false,
                dateRangeProspect:[],



                reportingFields:['DateCreatedDuplicte','First','Last','DuplicateOfficePrimary','Email','Number','Zip','Status','DuplicateStarred','Source','Tags','DuplicateNotes','DuplicateInterviewed','DuplicateHired'],
                reportingLabels:{
                    DateCreatedDuplicte: 'Date Created',
                    First: 'First Name',
                    Last: 'Last Name',
                    DuplicateOfficePrimary: 'Office Name',
                    Number: 'Phone Number',
                    Zip:'Postal Code',
                    DuplicateStarred:'Starred',
                    DuplicateNotes:'Notes',
                    DuplicateInterviewed:'Interviewed',
                    DuplicateHired:'Hired'
                },
                // ORGANIC CSV (1)
                reportingFields1:['DateCreatedDuplicte1','DuplicateFirst1','DuplicateLast1','DuplicateOffice1','DuplicateManager1','DuplicateEvent1','Email','Number','Zip','Status','Source','Tags','DuplicateNotes1'],
                reportingLabels1:{
                    DateCreatedDuplicte1: 'Date Created',
                    DuplicateFirst1: 'First Name',
                    DuplicateLast1: 'Last Name',
                    DuplicateOffice1: 'Office Name',
                    DuplicateManager1:'Manager Name',
                    DuplicateEvent1:'Event Name',
                    Number: 'Phone Number',
                    Zip:'Postal Code',
                    DuplicateNotes1:'Notes'
                },
                // INTERVIEW CSV (2)
                reportingFields2:['DateCreatedDuplicte2','DuplicateFirst2','DuplicateLast2','DuplicateOffice2','DuplicateManager2','DuplicateEvent2', 'DuplicateInterviewed2','Email','Number','Zip','Status','Source','Tags','DuplicateNotes2'],
                reportingLabels2:{
                    DateCreatedDuplicte2: 'Date Created',
                    DuplicateFirst2: 'First Name',
                    DuplicateLast2: 'Last Name',
                    DuplicateOffice2: 'Office Name',
                    DuplicateManager2:'Manager Name',
                    DuplicateEvent2:'Event Name',
                    DuplicateInterviewed2:'Interview Date',
                    Number: 'Phone Number',
                    Zip:'Postal Code',
                    DuplicateNotes2:'Notes'
                },
                // THIRDPOOL CSV (3)
                reportingFields3:['DateCreatedDuplicte3','DuplicateFirst3','DuplicateLast3','DuplicateOffice3','DuplicateManager3','DuplicateEvent3','Email','Number','Zip','Status','Source','Tags','DuplicateNotes3'],
                reportingLabels3:{
                    DateCreatedDuplicte3: 'Date Created',
                    DuplicateFirst3: 'First Name',
                    DuplicateLast3: 'Last Name',
                    DuplicateOffice3: 'Office Name',
                    DuplicateManager3:'Manager Name',
                    DuplicateEvent3:'Event Name',
                    Number: 'Phone Number',
                    Zip:'Postal Code',
                    DuplicateNotes3:'Notes'
                },
                // HIRE CSV (4)
                reportingFields4:['DateCreatedDuplicte4','DuplicateFirst4','DuplicateLast4','DuplicateOffice4','DuplicateManager4','DuplicateEvent4','DuplicateHire4','Email','Number','Zip','Status','Source','Tags','DuplicateNotes4'],
                reportingLabels4:{
                    DateCreatedDuplicte4: 'Date Created',
                    DuplicateFirst4: 'First Name',
                    DuplicateLast4: 'Last Name',
                    DuplicateOffice4: 'Office Name',
                    DuplicateManager4:'Manager Name',
                    DuplicateEvent4:'Event Name',
                    DuplicateHire4:'Hire Date',
                    Number: 'Phone Number',
                    Zip:'Postal Code',
                    DuplicateNotes4:'Notes'
                },
                // PRE-INTERVIEW CSV (5)
                reportingFields5:['DateCreatedDuplicte5','DuplicateFirst5','DuplicateLast5','DuplicateOffice5','DuplicateManager5','DuplicateEvent5','Email','Number','Zip','Status','Source','Tags','DuplicateNotes5'],
                reportingLabels5:{
                    DateCreatedDuplicte5: 'Date Created',
                    DuplicateFirst5: 'First Name',
                    DuplicateLast5: 'Last Name',
                    DuplicateOffice5: 'Office Name',
                    DuplicateManager5:'Manager Name',
                    DuplicateEvent5:'Event Name',
                    Number: 'Phone Number',
                    Zip:'Postal Code',
                    DuplicateNotes5:'Notes'
                },
                // POST-INTERVIEW CSV (6)
                reportingFields6:['DateCreatedDuplicte6','DuplicateFirst6','DuplicateLast6','DuplicateOffice6','DuplicateManager6','DuplicateEvent6','Email','Number','Zip','Status','Source','Tags','DuplicateNotes6'],
                reportingLabels6:{
                    DateCreatedDuplicte6: 'Date Created',
                    DuplicateFirst6: 'First Name',
                    DuplicateLast6: 'Last Name',
                    DuplicateOffice6: 'Office Name',
                    DuplicateManager6:'Manager Name',
                    DuplicateEvent6:'Event Name',
                    Number: 'Phone Number',
                    Zip:'Postal Code',
                    DuplicateNotes6:'Notes'
                },
                // OFFER CSV (7)
                reportingFields7:['DateCreatedDuplicte7','DuplicateFirst7','DuplicateLast7','DuplicateOffice7','DuplicateManager7','DuplicateEvent7','Email','Number','Zip','Status','Source','Tags','DuplicateNotes7'],
                reportingLabels7:{
                    DateCreatedDuplicte7: 'Date Created',
                    DuplicateFirst7: 'First Name',
                    DuplicateLast7: 'Last Name',
                    DuplicateOffice7: 'Office Name',
                    DuplicateManager7:'Manager Name',
                    DuplicateEvent7:'Event Name',
                    Number: 'Phone Number',
                    Zip:'Postal Code',
                    DuplicateNotes7:'Notes'
                },
                // LOST TO COMPETITORS (8)
                reportingFields8:['DateCreatedDuplicte8','DuplicateFirst8','DuplicateLast8','DuplicateOffice8','DuplicateManager8','DuplicateEvent8','Email','Number','Zip','Status','Source','Tags','DuplicateNotes8'],
                reportingLabels8:{
                    DateCreatedDuplicte8: 'Date Created',
                    DuplicateFirst8: 'First Name',
                    DuplicateLast8: 'Last Name',
                    DuplicateOffice8: 'Office Name',
                    DuplicateManager8:'Manager Name',
                    DuplicateEvent8:'Event Name',
                    Number: 'Phone Number',
                    Zip:'Postal Code',
                    DuplicateNotes8:'Notes'
                },
                // PROSPECT SENT TO MANAGER
                managerFields:['DuplicateSentOn9','DuplicateFirst9','DuplicateLast9','DuplicateEmail9','DuplicateNumber9','DuplicateZip9','DuplicateSource9','DuplicateNotes9','DuplicateOffice9','DuplicateMName9','DuplicateMEmail9','DuplicateMNumber9','DuplicateReviewedOn9','DuplicateRating9','DuplicateMNote9'],
                managerLabels:{
                    DuplicateSentOn9: 'Date Sent to Manager',
                    DuplicateFirst9: 'Prospect First Name',
                    DuplicateLast9: 'Prospect Last Name',
                    DuplicateEmail9:'Prospect Email',
                    DuplicateNumber9: 'Prospect Phone Number',
                    DuplicateZip9:'Prospect Postal Code',
                    DuplicateSource9:'Prospect Source',
                    DuplicateNotes9:'Recruiter Notes',
                    DuplicateOffice9:'Office',
                    DuplicateMName9:'Manager Name',
                    DuplicateMEmail9:'Manager Email',
                    DuplicateMNumber9:'Manager Phone Number',
                    DuplicateReviewedOn9:'Date of Manager Review',
                    DuplicateRating9:'Rating from Manager',
                    DuplicateMNote9:'Manager Notes'
                    
                },
                prospectMangerCSVList:[],

                downloadCount:0,
                OrganicCSVDownloadCount:0,
                InterviewCSVDownloadCount:0,
                ThirdPoolCSVDownloadCount:0,
                HireCSVDownloadCount:0,
                PreInterviewCSVDownloadCount:0,
                PostInterviewCSVDownloadCount:0,
                OfferCSVDownloadCount:0,
                LostToCompCSVDownloadCount:0,
                SentProspectManagerCSVDownloadCount:0,
                
                isShowTagAnalytics:false,
                ThirdPoolProspectsCSVList:[],
                Tone:[],
                NotThirdPoolProspectsCSVList:[],
                PreInterviewNurtureCSVList:[],
                PostInterviewNurtureCSVList:[],
                InterviewCSVList:[],
                OffersCSVList:[],
                HiresCSVList:[],
                LosttoCompetitorCSVList:[],

                monthoptions: [
                    { value: 'All', text: 'All' },
                    { value: 'January', text: 'January' },
                    { value: 'February', text: 'February' },
                    { value: 'March', text: 'March' },
                    { value: 'April', text: 'April' },
                    { value: 'May', text: 'May' },
                    { value: 'June', text: 'June' },
                    { value: 'July', text: 'July' },
                    { value: 'August', text: 'August' },
                    { value: 'September', text: 'September' },
                    { value: 'October', text: 'October' },
                    { value: 'November', text: 'November' },
                    { value: 'December', text: 'December ' },
                ],
                yearoptions: [
                    { value: '2022', text: '2022' },
                    { value: '2023', text: '2023' },
                    { value: '2024', text: '2024' },
                    { value: '2025', text: '2025' },
                ],
                YearFilterDisabled: true,
                monthFilterValue:this.getMonthNames(),
                yearFilterValue:GetOnlyYear,
                MonthYear:this.getMonthNames()+''+GetOnlyYear,
                AdCostPerProspect:0,
                TotalCostPerProspect:0,
                AdCostPerHired:0,
                TotalCostPerHired:0,

                maintainAllflag:0,
                monthlyYearFinalKey:'',

                LoadMapStatus:false,
                HideMaps:true,

                InterviewedTileThirdPoolProspectsCount: 0,
                InterviewedTileOrganicProspectsCount: 0,
                InterviewNoShowTileThirdPoolProspectsCount: 0,
                InterviewNoShowTileOrganicProspectsCount: 0,
                HiredTileThirdPoolProspectsCount: 0,
                HiredTileOrganicProspectsCount: 0,
                LostToCompetitorTileThirdPoolProspectsCount: 0,
                LostToCompetitorTileOrganicProspectsCount: 0,
                
            }
		},
        
	}
</script>

<style scoped>
    .tatext-card-layout{padding: 12px 2px;box-shadow: 0 2px 10px -1px rgb(69 90 100 / 30%);margin-bottom: 30px;transition: box-shadow .2s ease-in-out;}
    .text-c-blue { background-color: #06187c; color: white;}
    .f-36 { font-size: 36px;}
    .loader1 {
        position: fixed;
        z-index: 1010;
        top: 50%;
        margin: auto;
        left: 50%;
        z-index: 1111;
    }

    .loader1:before {
        content: "";
        display: block;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        min-height: 100%;
        background-color: rgba(0, 0, 0, 0.3);
        z-index: 1111;
    }

    .lds-ripple {
        display: inline-block;
        top: 50%;
        position: relative;
        width: 64px;
        height: 64px;
    }

    .lds-ripple div {
        position: absolute;
        top: 50%;
        border: 4px solid #000000;
        opacity: 1;
        border-radius: 50%;
        animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
    }

    .lds-ripple div:nth-child(2) {
        animation-delay: -0.5s;
    }
    .first-chart .apexcharts-canvas {
        margin-left: auto !important;
    }
    .loader4 {
   width:30px;
   height:30px;
   display:inline-block;
   padding:0px;
   border-radius:100%;
   border:5px solid;
   border-top-color:#fff;
   border-bottom-color:rgba(255,255,255, 0.3);
   border-left-color:#fff;
   border-right-color:rgba(255,255,255, 0.3);
   -webkit-animation: loader4 1s ease-in-out infinite;
   animation: loader4 1s ease-in-out infinite;
}

.loader-blue .loader4{
    border-top-color:#06187c;
   border-bottom-color:rgba(255,255,255, 0.3);
   border-left-color:#06187c;display: flex;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: 0;
    bottom: 0;
   border-right-color:rgba(255,255,255, 0.3);
}
.loader-blue{
    position: absolute;
    padding-left: 0px;
    top: 0;z-index: 9999;
    margin: auto;
    bottom: 0;
}
@keyframes loader4 {
   from {transform: rotate(0deg);}
   to {transform: rotate(360deg);}
}
@-webkit-keyframes loader4 {
   from {-webkit-transform: rotate(0deg);}
   to {-webkit-transform: rotate(360deg);}
}
/* 
.custom-icon{
        display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
} */

    @keyframes lds-ripple {
        0% {
            top: 28px;
            left: 28px;
            width: 0;
            height: 0;
            opacity: 1;
        }
        100% {
            top: -1px;
            left: -1px;
            width: 58px;
            height: 58px;
            opacity: 0;
        }
    }
</style>

<style>
.tooltip-inner .table{
    color:#fff;
}
.select.multiSelectdiv .btn-select{
    margin: 0px 15px;
    border-radius: 3px;
    color: #007bff;
    border-color: #007bff;
    padding: 5px 30px;
    background: transparent;
    font-size: 14px;
    line-height: 1.5;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
}
.select.multiSelectdiv .btn-select:hover{
    background: #007bff;
    color:#fff;
}
.select.multiSelectdiv .btn-select:focus{
    outline:none;
    box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 50%);
}
.select.multiSelectdiv .checkBoxContainer{
    padding: 0px;
    margin: 0px;
}
.select.multiSelectdiv .checkBoxContainer .selectItem {
    padding: 8px;
    margin: 0px;
    font-size: 15px;
    border-bottom: 1px solid #ddd;
}
.select.multiSelectdiv .checkBoxContainer .selectItem:last-child {
    border:none;
}
.HeadingCenter{
    text-align: center;
    margin-bottom:20px;
    font-weight: 600;
}
.financialshead{
    border-top: 1px solid #ddd;
    padding-top: 30px;
}
.rowphases{
    justify-content: center;
}
.rowphases .col-lg-2, .rowphases .col-lg-4{
    padding: 3px;
}
.rowphasesMiddle .col-lg-2{
    max-width: 10.50%!important;
}
.rowphases .col-lg-2{
    max-width: 12.50%;
}
.rowphases .col-lg-4{
    max-width: 32%;
}
.col-auto{
    padding-left:10px!important;
}
.rowphases .col-lg-2 .col-auto h6, 
.rowphases .col-lg-4 .col-auto h6{
    font-size: 13px;
    line-height: 20px;
}
.mapchartsection{
    margin-top: 20px;
    margin-bottom:30px;
}
.mapchartsection .chartrow{
    padding-top:10px;
}
.MatrixExportIcon{
	color: #ffffff;
    float: right;
    position: absolute;
    right: 6px;
    bottom: 20px;
    border-radius: 2px;
    cursor: pointer;
}
.MatrixExportIcon .fa-icon{
    height:13px;
}
.select .helperContainer{
    display: none!important;
    padding:0px;
}
.checkboxLayer{
    border: solid #efefef;
    border-radius: 2px;
}
.checkboxLayer .tab .tab-item span{
    padding:5px 35px;
}
.select .checkboxLayer {
    border:1px solid #efefef!important;
    border-radius: 2px!important;
    min-width: 405px!important;
}
#map {
    position: absolute;
    top: 10px;
    bottom: 0;
    width: 100%;
    left: 0;
    right: 0;
    padding: 10px !important;
    display: inline-block;
    height: 418px;
    /* width: 100%; */
    border:1px solid #e6e6e6;
}
.distance-container {
    position: absolute;
    top: 10px;
    left: 50px;
    z-index: 1;
    font-weight: 600;
    /* background: #ccc; */
    height: 22px;
    padding: 0px 5px;
    color: #fff;
}
.distance-container > * {
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 11px;
    line-height: 18px;
    display: block;
    margin: 0;
    padding: 5px 10px;
    border-radius: 3px;
}
/* .mapboxgl-map canvas.mapboxgl-canvas {
    width: 100% !important;
    height: 100% !important;
} */
.select .selectItem{
    padding: 0px!important;
    min-height:auto!important;
    border:none!important;
}
.stageChartStyle .apexcharts-legend.apexcharts-align-center {
    width:45%;
}
.financialfiltersection .financialfilter{
    float:left;
    margin-right:10px;
    width:350px;
}
.tooltip-inner {
    max-width: 600px!important;
}

.tileNumber{
    float: left;
    position: absolute;
    bottom: 10px;
}
</style>